import React, { useState, useContext, useEffect, useRef } from "react";
import { UserInformationContext, C4FStatusContext, ReferenceDataContext } from "../main/App";
import { Row, Col, Button, ButtonGroup, Form, Alert, Container, InputGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import C4FSimpleTable from "../common/C4FSimpleTable";
import { Map, ZoomControl } from "pigeon-maps";
import { addCounter, getNextCounterValue, getUnicodeFlag, isEmptyString, isInteger, max, min, truncateString } from "../common/Helpers";
import C4FChat from "../common/C4FChat";
import C4FDetailedProfile from "../calendar/C4FDetailedProfile";
import C4FInfoButton from "../common/C4FInfoButton";
import DataCaptureModal from "../common/DataCaptureModal";
import '../css/general.css';
import axios from "axios";
import config from "../etc/config.json";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { sectorBonificationTypes, sectorSurfaceTypes } from "../race/RaceEngine";
import C4FSimpleTextField from "../common/C4FSimpleTextField";
import C4FReferenceDataSelection from "../common/C4FReferenceDataSelection";

function RaceEditor(props) {

  const { userInformation } = useContext(UserInformationContext);
  const { handleBackendRequest, raiseError } = useContext(C4FStatusContext);
  const { raceRulesets, recurringEvents, countries } = useContext(ReferenceDataContext);
  const [userCanEditSelectedProfile, setUserCanEditSelectedProfile] = useState(false);
  const [userCanEditSelectedRace, setUserCanEditSelectedRace] = useState(false);
  const [tab, setTab] = useState('calendar');
  const [showProfileList, toggleProfileList] = useState(true);
  const [showProfileOverview, toggleProfileOverview] = useState(false);
  const [showProfileMap, toggleProfileMap] = useState(false);
  const [showProfileDetails, toggleProfileDetails] = useState(false);
  const [showRaceList, toggleRaceList] = useState(true);
  const [showRaceDetails, toggleRaceDetails] = useState(true);
  const [showRaceStages, toggleRaceStages] = useState(true);
  const [showRaceEditions, toggleRaceEditions] = useState(true);
  const [showDesignerNameChangeModal, setShowDesignerNameChangeModal] = useState(false);
  const [showSearchProfileModal, setShowSearchProfileModal] = useState(false);
  const [refreshImage, doRefreshImage] = useState(0);
  const [raceFilter, setRaceFilter] = useState([]);
  const [profileFilter, setProfileFilter] = useState([]);
  const [profileClipboard, setProfileClipboard] = useState([]);
  const [editorProfiles, setEditorProfiles] = useState([]);
  const [selectedEditorProfile, setSelectedEditorProfile] = useState(null);
  const [selectedEditorProfileBackup, setSelectedEditorProfileBackup] = useState(null);
  const [detailedAction, setDetailedAction] = useState('editSector');
  const [selectedSector, setSelectedSector] = useState(null);
  const [saveProfileRequired, setSaveProfileRequired] = useState(false);
  const [saveRaceRequired, setSaveRaceRequired] = useState(false);
  const [circuitFrom, setCircuitFrom] = useState(1);
  const [circuitTo, setCircuitTo] = useState(2);
  const [circuitLaps, setCircuitLaps] = useState(1);
  const [circuitInsertAfter, setCircuitInsertAfter] = useState(0);
  const [races, setRaces] = useState([]);
  const [calendarRaces, setCalendarRaces] = useState([]);
  const [selectedRace, setSelectedRace] = useState(null);
  const [selectedRaceBackup, setSelectedRaceBackup] = useState(null);
  const [selectedStage, setSelectedStage] = useState(null);
  const [selectedRaceEdition, setSelectedRaceEdition] = useState(null);
  const [selectedCalendarRace, setSelectedCalendarRace] = useState(null);
  const [selectedCalendarStage, setSelectedCalendarStage] = useState(null);
  const [selectedCalendarProfile, setSelectedCalendarProfile] = useState(null);
  const [recurringEventFilter, setRecurringEventFilter] = useState('');
  const [recurringEventFilterRegex, setRecurringEventFilterRegex] = useState(new RegExp('', 'i'));
  const gpxFile = useRef(null)
  const profileExcelFile = useRef(null)

  function isAdmin() {
    return userInformation !== null &&
      (userInformation.roles.includes('Admin') ||
        userInformation.roles.includes('CalendarPlanner'));
  }

  const projects = [
    'OneDayReal', 
    'OneDayFantasy', 
    'GrandTour', 
    'TourReal', 
    'TourFantasy', 
    'WinterClassics', 
    'NationalChampionship', 
    'WorldChampionship'
  ];

  const Line = ({ mapState: { width, height }, latLngToPixel, coordsArray, style = { stroke: 'rgb(255,0,0)', strokeWidth: 2 } }) => {
    if (coordsArray.length < 2) {
      return null
    }

    let lines = []
    let pixel = latLngToPixel(coordsArray[0])

    for (let i = 1; i < coordsArray.length; i++) {
      let pixel2 = latLngToPixel(coordsArray[i])
      lines.push(<line key={i} x1={pixel[0]} y1={pixel[1]} x2={pixel2[0]} y2={pixel2[1]} style={style} />)
      pixel = pixel2
    }

    return (
      <svg width={width} height={height} style={{ top: 0, left: 0 }}>
        {lines}
      </svg>
    )
  }

  function readLocalFile(file, callback) {
    let reader = new FileReader();
    reader.onload = callback;
    reader.readAsText(file, "UTF-8");
  }

  function parseGpx(gpx, file) {
    let gpxParser = require('gpxparser');
    let gpxObject = new gpxParser();
    gpxObject.parse(gpx);
    gpxToC4FTrack(gpxObject, file);
  }

  //This function takes in latitude and longitude of two location and returns the distance between them as the crow flies (in km)
  function distanceBetweenPoints(lat1, lon1, lat2, lon2) {
    var R = 6371; // km
    var dLat = degreesToRadians(lat2 - lat1);
    var dLon = degreesToRadians(lon2 - lon1);
    var latRadians1 = degreesToRadians(lat1);
    var latRadians2 = degreesToRadians(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(latRadians1) * Math.cos(latRadians2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  }
  function degreesToRadians(deg) {
    return deg * Math.PI / 180;
  }

  function gpxToC4FTrack(gpx, file) {
    if (!('tracks' in gpx)) throw new Error("no track in GPX");
    console.log(gpx);
    let points = gpx.tracks[0].points;
    let accumulatedDistance = 0;
    let sectors = [];
    let previousSectorC4FHeight = points[0].ele;

    let minC4FHeight = previousSectorC4FHeight, maxC4FHeight = previousSectorC4FHeight;

    for (let j = 1; j < points.length; j++) {
      accumulatedDistance += distanceBetweenPoints(points[j - 1].lat, points[j - 1].lon, points[j].lat, points[j].lon);
      if (accumulatedDistance >= sectors.length + 1) {
        let c4fIncline = Math.round((points[j].ele - previousSectorC4FHeight) / 10);
        previousSectorC4FHeight += c4fIncline * 10;
        minC4FHeight = Math.min(previousSectorC4FHeight, minC4FHeight);
        maxC4FHeight = Math.max(previousSectorC4FHeight, maxC4FHeight);

        sectors.push({
          incline: c4fIncline,
          latitude: points[j].lat,
          longitude: points[j].lon,
          height: previousSectorC4FHeight,
          heightGPX: points[j].ele,
          label: null,
          bonification: 'None',
          surface: 'Asphalt'
        });
      }
    }

    handleUpdateSelectedProfile({
      ...selectedEditorProfile,
      profileCode: 'profileCode' in selectedEditorProfile && selectedEditorProfile.profileCode !== null && selectedEditorProfile.profileCode !== '' ?
        selectedEditorProfile.profileCode : file.name.split('.')[0].replaceAll('-', '_'),
      startingHeight: points[0].ele,
      minimumDisplayHeight: Math.floor(minC4FHeight / 1000) * 1000,
      maximumDisplayHeight: Math.ceil(maxC4FHeight / 1000) * 1000,
      sectors: sectors
    });
  }

  function prepareArrayForExcel(array) {
    let object = {};
    array.forEach(item => object[item] = item);
    return [object];
  }

  async function exportProfileExcel(profile) {

    const response = await fetch(process.env.PUBLIC_URL + "/templates/profile_template.xlsx");
    // console.log(response);
    const buffer = await response.arrayBuffer();

    let workbook = XLSX.read(buffer);
    let overviewSheet = workbook.Sheets["Profile"];

    let overview = [];
    Object.keys(profile).forEach(key => {
      if (key !== 'sectors')
        overview.push({
          key: key,
          value: profile[key]
        })
    })
    XLSX.utils.sheet_add_json(overviewSheet, overview, {
      origin: "A2",
      skipHeader: true
    });

    let sectorSheet = workbook.Sheets["Sectors"];
    let sectorsOutput = profile.sectors.map((s, i) => ({
      Sector: i + 1,
      latitude: s.latitude ?? '',
      longitude: s.longitude ?? '',
      incline: s.incline ?? '',
      surface: s.surface ?? '',
      height: s.height ?? '',
      heightGPX: s.heightGPX ?? '',
      label: s.label ?? '',
      bonification: s.bonification ?? ''
    }));    

    XLSX.utils.sheet_add_json(sectorSheet, sectorsOutput, {
      origin: "A2",
      skipHeader: true
    });
    
    let listsSheet = workbook.Sheets["Lists"];
    XLSX.utils.sheet_add_json(listsSheet, 
      prepareArrayForExcel(sectorSurfaceTypes), 
      {
        origin: "B1",
        skipHeader: true
      });
    XLSX.utils.sheet_add_json(listsSheet, 
      prepareArrayForExcel(sectorBonificationTypes.map(t => t.name)), 
      {
        origin: "B2",
        skipHeader: true
      });

    let bufferOut = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    saveAs(new Blob([bufferOut]), "profile_" + profile.profileCode + ".xlsx");
  }

  async function parseProfileExcel(file) {
    console.log(selectedEditorProfile);
    let updatedEditorProfile = structuredClone(selectedEditorProfile);    
    const buffer = await file.arrayBuffer();
    const workbook = XLSX.read(buffer);
    const sectorsSheet = workbook.Sheets["Sectors"];
    const sectorsRows = XLSX.utils.sheet_to_json(sectorsSheet);

    let sectors = sectorsRows
      .filter(sector => sector.Sector)
      .map(r => ({
        incline: Number(r.incline) || 0,
        latitude: r.latitude || null,
        longitude: r.longitude || null,
        surface: r.surface || "Asphalt",
        height: Number(r.height) || 0,
        heightGPX: Number(r.heightGPX) || 0,
        bonification: r.bonification || "None",
        label: r.label || ""
      }));
    let validationResult = validateSectors(sectors);
    if (!validationResult.result)
      raiseError('Validation Error', 0, <>{validationResult.messages.map(m => <>{m}<br></br></>)}</>);
    let previousHeight = updatedEditorProfile.startingHeight;
    for (let i = 0; i < sectors.length; i++) {
      previousHeight += sectors[i].incline * 10;
      sectors[i].height = previousHeight;
    }
    updatedEditorProfile.sectors = sectors;
    setSelectedEditorProfile(updatedEditorProfile);
    setSelectedEditorProfileBackup(structuredClone(updatedEditorProfile));
    console.log(sectors);
    
  }

  function validateSectors(sectors) {
    let messages = [];
    if (!sectors) {
      return {
        messages: ['No sectors in profile'],
        result: false
      }
    }
    let containsGeoCoordinates = sectors.some(s => s.latitude !== null);
    if (sectors.length === 0)
      messages.push('No sectors in profile');
    if (sectors.length > 300)
      messages.push('Max. 300 sectors are allowed (actual: ' + sectors.length + ')');
    sectors.forEach((sector, index) => {
      if (!isInteger(sector.incline))
        messages.push('Incline of sector ' + (index + 1) + ' (' + sector.incline + ') is invalid');
      else if (sector.incline < - 30 || sector.incline > 30)
        messages.push('Incline of sector ' + (index + 1) + ' is out of range (-30 .. 30)');
      if (!sectorSurfaceTypes.includes(sector.surface))
        messages.push(sector.surface + ' is an invalid surface (sector ' + (index + 1) + ')');
      if (!sectorBonificationTypes.map(t => t.name).includes(sector.bonification))
        messages.push(sector.bonification + ' is an invalid bonification (sector ' + (index + 1) + ')');
      if (containsGeoCoordinates && (sector.latitude === null || sector.longitude === null))
        messages.push('Either all or no sectors need to contain geo coordinates, sector ' + (index + 1) + ' is missing them');
    });

    return {
      messages: messages,
      result: messages.length === 0
    }
  }

  function validateProfile(profile) {
    let result = validateSectors(profile.sectors);
    let messages = result.messages;
    
    if (profile.profileCode.length < 3 || !profile.profileCode.match(/^(?=[a-zA-Z0-9_]*[a-zA-Z])[a-zA-Z0-9_]+$/))
      messages.push('valid profileCode needs to be provided (at least three characters, at least one letter, no whitespace, only letters, numbers and underscore (_))');
    if (isEmptyString(profile.project))
      messages.push('project needs to be provided');

    // get min and max altitude and check against profile display settings
    let allHeights = profile.sectors.map(s => s.height);
    if (max(allHeights, 0) > profile.maximumDisplayHeight)
      messages.push('Max height ' + max(allHeights, 0) + ' exceeds maximum display height ' + profile.maximumDisplayHeight);
    if (min(allHeights, 0) < profile.minimumDisplayHeight)
      messages.push('Min height ' + min(allHeights, 0) + ' falls short of minimum display height ' + profile.minimumDisplayHeight);

    // get all bonifications
    let allBonifications = profile.sectors.filter(s => s.bonification && s.bonification !== '' && s.bonification !== 'None').map(s => s.bonification);
    let validBonifications = sectorBonificationTypes
      .filter(b => 
        (!b.projectBlacklist || !b.projectBlacklist.includes(profile.project)) &&
        (!b.projectWhitelist || b.projectWhitelist.includes(profile.project)))
      .map(b => b.name);
    console.log(allBonifications);
    console.log(validBonifications);
    if (allBonifications.some(b => !validBonifications.includes(b)))
      messages.push('Profile contains bonification, which is not allowed for the selected project (special bonifications are only for GTs, NC and WC only allows sprint)');

    return {
      messages: messages,
      result: messages.length === 0
    }
  }

  function getProfileCenter() {
    let minLat = selectedEditorProfile.sectors[0].latitude, maxLat = selectedEditorProfile.sectors[0].latitude;
    let minLon = selectedEditorProfile.sectors[0].longitude, maxLon = selectedEditorProfile.sectors[0].longitude;
    selectedEditorProfile.sectors.forEach(sector => {
      minLat = Math.min(minLat, sector.latitude);
      maxLat = Math.max(maxLat, sector.latitude);
      minLon = Math.min(minLon, sector.longitude);
      maxLon = Math.max(maxLon, sector.longitude);
    });

    return [(minLat + maxLat) / 2, (minLon + maxLon) / 2];
  }

  function copyToCliboard() {
    let copyFrom = Number(circuitFrom);
    let copyTo = Number(circuitTo);
    if (copyFrom > copyTo) {
      raiseError('Technical Error', 0, 'Section needs to end after it starts, not before.');
      return;
    }
    if (copyFrom > selectedEditorProfile.sectors.length ||
      copyTo > selectedEditorProfile.sectors.length ||
      copyFrom < 1 || copyTo < 1) {
      raiseError('Technical Error', 0, 'Section outside profile, min 1, max ' + selectedEditorProfile.sectors.length);
      return;
    }

    let sectorsToCopy = [];
    for (let i = copyFrom; i <= copyTo; i++)
      sectorsToCopy.push(selectedEditorProfile.sectors[i - 1]);

    setProfileClipboard(sectorsToCopy);
  }

  function pasteFromCliboard() {
    let insertAfter = Number(circuitInsertAfter);
    let sectorsToPaste = profileClipboard;
    if (insertAfter < 0 || insertAfter > selectedEditorProfile.sectors.length) {

      raiseError('Technical Error', 0, 'Section can only be added inside profile, min 0, max ' + selectedEditorProfile.sectors.length);
      return;
    }
    // only sections with geo coordinates can be added to a profile with geo coordinates
    if (selectedEditorProfile.sectors.some(s => 'latitude' in s) &&
      !sectorsToPaste.some(s => 'latitude' in s)) {
      raiseError('Technical Error', 0, 'Only sections with geo coordinates can be added to a profile with geo coordinates');
      return;
    }

    // strip geo coordinates from pasted section, if the target profile doesn't contain geo coordinates
    if (!selectedEditorProfile.sectors.some(s => 'latitude' in s) &&
      sectorsToPaste.some(s => 'latitude' in s)) {
      sectorsToPaste = sectorsToPaste.map(sector => ({
        ...sector,
        heightGPX: null,
        latitude: null,
        longitude: null
      }));
    }

    let sectorsBeforeInsertion = selectedEditorProfile.sectors.slice(0, insertAfter);
    let sectorsAfterInsertion = selectedEditorProfile.sectors.slice(insertAfter, selectedEditorProfile.sectors.length);
    let sectorsCombined = sectorsBeforeInsertion.concat(sectorsToPaste).concat(sectorsAfterInsertion);

    if (sectorsCombined.length > 300) {
      raiseError('Technical Error', 0, 'Maximum length of 300 exceeded.');
      return;
    }


    handleUpdateSelectedProfile({
      ...selectedEditorProfile,
      sectors: sectorsCombined
    });
  }

  function deleteSectors() {
    let deleteFrom = Number(circuitFrom);
    let deleteTo = Number(circuitTo);
    if (deleteFrom > deleteTo) {
      raiseError('Technical Error', 0, 'Section needs to end after it starts, not before.');
      return;
    }
    if (deleteFrom > selectedEditorProfile.sectors.length ||
      deleteTo > selectedEditorProfile.sectors.length ||
      deleteFrom < 1 || deleteTo < 1) {
      raiseError('Technical Error', 0, 'Section outside profile, min 1, max ' + selectedEditorProfile.sectors.length);
      return;
    }

    let sectorsBeforeDeletion = selectedEditorProfile.sectors.slice(0, deleteFrom - 1);
    let sectorsAfterDeletion = selectedEditorProfile.sectors.slice(deleteTo, selectedEditorProfile.sectors.length);

    handleUpdateSelectedProfile({
      ...selectedEditorProfile,
      sectors: sectorsBeforeDeletion.concat(sectorsAfterDeletion)
    });
  }

  function insertCircuit() {
    let circuitToNumber = Number(circuitTo);
    let circuitFromNumber = Number(circuitFrom);
    let circuitInsertAfterNumber = Number(circuitInsertAfter);
    let circuitLapsNumber = Number(circuitLaps);
    if (circuitFromNumber > circuitToNumber) {
      raiseError('Technical Error', 0, 'Circuit needs to end after it starts, not before.');
      return;
    }
    if (circuitFromNumber === circuitToNumber) {
      raiseError('Technical Error', 0, 'For 1km circuits, use the clone option on the left.');
      return;
    }
    if (circuitLapsNumber < 1) {
      raiseError('Technical Error', 0, 'Minimum number of laps is 1.');
      return;
    }
    if (circuitFromNumber > selectedEditorProfile.sectors.length ||
      circuitToNumber > selectedEditorProfile.sectors.length ||
      circuitFromNumber < 1 || circuitToNumber < 1) {
      raiseError('Technical Error', 0, 'Circuit outside profile, min 1, max ' + selectedEditorProfile.sectors.length);
      return;
    }
    if (circuitInsertAfterNumber < 0 || circuitInsertAfterNumber > selectedEditorProfile.sectors.length) {
      raiseError('Technical Error', 0, 'Circuit can only be added inside profile, min 0, max ' + selectedEditorProfile.sectors.length);
      return;
    }
    let sectorStart = selectedEditorProfile.sectors[circuitFromNumber - 1];
    let sectorEnd = selectedEditorProfile.sectors[circuitToNumber - 1];
    let heightStartCircuit = sectorStart.height - sectorStart.incline * 10;
    let heightEndCircuit = sectorEnd.height;
    if (heightStartCircuit !== heightEndCircuit) {
      raiseError('Technical Error', 0, 'Circuit needs to start and end on the same height');
      return;
    }

    let sectorsBeforeCircuit = selectedEditorProfile.sectors.slice(0, circuitInsertAfterNumber);
    let sectorsCircuit = selectedEditorProfile.sectors.slice(circuitFromNumber - 1, circuitToNumber);
    let sectorsCircuitAllLaps = [];
    for (let i = 1; i <= circuitLapsNumber; i++)
      sectorsCircuitAllLaps = sectorsCircuitAllLaps.concat(sectorsCircuit);
    let sectorsAfterCircuit = selectedEditorProfile.sectors.slice(circuitInsertAfterNumber, selectedEditorProfile.sectors.length);
    let sectorsWithCircuit = sectorsBeforeCircuit.concat(sectorsCircuitAllLaps).concat(sectorsAfterCircuit);


    if (sectorsWithCircuit.length > 300) {
      raiseError('Technical Error', 0, 'Maximum length of 300 exceeded.');
      return;
    }

    handleUpdateSelectedProfile({
      ...selectedEditorProfile,
      sectors: sectorsWithCircuit
    });
  }

  function createNewProfile() {
    let editorProfile = {
      profileCode: '',
      name: '',
      description: 'custom description',
      status: 'Draft',
      project: 'OneDayFantasy',
      countryStart: 'DE',
      countryFinish: 'FR',
      startingHeight: 0,
      minimumDisplayHeight: -100,
      maximumDisplayHeight: 1000,
      designer: userInformation === null ? 3341 : userInformation.userID,
      designerName: userInformation === null ? 'Alkworld' : userInformation.userName,
      signature: userInformation === null ? 'Alkworld' : userInformation.userName,
      sectors: []
    }
    setSelectedEditorProfileBackup(JSON.parse(JSON.stringify(editorProfile)));
    handleUpdateSelectedProfile(editorProfile);
    toggleProfileOverview(true);
    toggleProfileDetails(true);
  }

  function addSector() {
    let sectors = [{
      incline: 0,
      surface: 'Asphalt',
      height: 0,
      heightGPX: null,
      latitude: null,
      longitude: null,
      bonification: 'None',
      label: null
    }];
    handleUpdateSelectedProfile({
      ...selectedEditorProfile,
      sectors: sectors
    });
  }

  function editSector(sectorToEdit) {
    setSelectedSector(sectorToEdit);
    setDetailedAction('editSector');

  }

  function cloneSector(sectorToClone) {
    let sectors = selectedEditorProfile.sectors.slice();
    sectors.splice(sectorToClone.km - 1, 0, sectors[sectorToClone.km - 1]);
    let editorProfileLocal = {
      ...selectedEditorProfile,
      sectors: sectors
    };
    handleUpdateSelectedProfile(editorProfileLocal);
  }

  function deleteSector(sectorToDelete) {
    let sectors = selectedEditorProfile.sectors.slice();
    sectors.splice(sectorToDelete.km - 1, 1);
    let editorProfileLocal = {
      ...selectedEditorProfile,
      sectors: sectors
    };
    handleUpdateSelectedProfile(editorProfileLocal);
  }

  function handleSetStartingHeight(startingHeight) {
    if (!isInteger(startingHeight))
      return;
    handleUpdateSelectedProfile({
      ...selectedEditorProfile,
      startingHeight: parseInt(startingHeight)
    });
  }
  function handleSetMinimumDisplayHeight(minimumDisplayHeight) {
    if (!isInteger(minimumDisplayHeight))
      return;
    handleUpdateSelectedProfile({
      ...selectedEditorProfile,
      minimumDisplayHeight: parseInt(minimumDisplayHeight)
    });
  }
  function handleSetMaximumDisplayHeight(maximumDisplayHeight) {
    if (!isInteger(maximumDisplayHeight))
      return;
    handleUpdateSelectedProfile({
      ...selectedEditorProfile,
      maximumDisplayHeight: parseInt(maximumDisplayHeight)
    });
  }

  function restoreProfile() {
    handleSaveEditorProfile({
      ...selectedEditorProfile,
      status: 'Design'
    });
  }

  function discardProfile() {
    handleSaveEditorProfile({
      ...selectedEditorProfile,
      status: 'ToBeDeleted'
    });
  }

  function approveProfile() {
    handleSaveEditorProfile({
      ...selectedEditorProfile,
      status: 'Approved'
    });
  }

  function reopenProfile() {
    handleSaveEditorProfile({
      ...selectedEditorProfile,
      status: 'Design'
    });
  }

  function cloneProfile() {
    let profile = {
      ...selectedEditorProfile,
      profileCode: '',
      designer: userInformation.userID,
      designerName: userInformation.userName,
      status: 'Draft'
    }
    setSelectedEditorProfileBackup(structuredClone(profile));
    handleUpdateSelectedProfile(profile, true);
  }

  function startProfileReview() {
    handleSaveEditorProfile({
      ...selectedEditorProfile,
      status: 'Review'
    });
  }

  function handleUpdateSelectedProfile(editorProfile, saveRequired = true) {
    setSelectedEditorProfile(editorProfile);
    setSaveProfileRequired(saveRequired);
    if (userInformation !== null &&
      ((['Review', 'Draft', 'Design'].includes(editorProfile.status) && userInformation.userName === editorProfile.designerName) ||
      (['Review', 'Approved', 'Archived', 'ToBeDeleted'].includes(editorProfile.status) && isAdmin())))
      setUserCanEditSelectedProfile(true);
    else
      setUserCanEditSelectedProfile(false);
  }

  function handleRevertProfileChanges() {
    handleUpdateSelectedProfile(selectedEditorProfileBackup, false);
  }

  function editProfileForStage() {
    setTab('profileEditor');
    loadEditorProfile(editorProfiles.find(ep => ep.profileCode === selectedStage.profileCode));
  }

  // function cloneProfile() {
  //   handleUpdateSelectedProfile({
  //     ...selectedEditorProfile,
  //     id: 'tempo' + getNextCounterValue('editorCounter'),
  //     status: 'Draft',
  //     profileCode: ''
  //   });
  // }

  function deleteProfile() {
    handleBackendRequest('DELETE', '/profile/' + selectedEditorProfile.profileCode, null, null,
      function () {
        setEditorProfiles(editorProfiles.filter(ep => ep.profileCode !== selectedEditorProfile.profileCode));
        setSelectedEditorProfile(null);
        setSelectedEditorProfileBackup(null);
      }, false);
  }

  function initiateChangeDesigner() {
    setShowDesignerNameChangeModal(true);
  }

  function executeChangeDesigner(data) {
    setShowDesignerNameChangeModal(false);
    let teamName = data[0].parameterValue;

    // find designer
    handleBackendRequest('GET', '/team/' + teamName, null, null,
      function (team) {
        if (selectedEditorProfile.designerName === team.teamName) {
          raiseError('Technical Error', 0, 'Designer unchanged.');
          return;
        }

        // save, if team was found
        handleSaveEditorProfile({
          ...selectedEditorProfile,
          designer: team.owner,
          designerName: team.teamName,
          signature: team.teamName
        });
      });

  }

  function createProfileForStage() {
    let editorProfile = {
      profileCode: '',
      name: selectedRace.stages.length > 1 ? selectedStage.name : selectedRace.name,
      description: selectedRace.stages.length > 1 ? selectedStage.description : selectedRace.description,
      status: 'Draft',
      countryStart: 'DE',
      countryFinish: 'FR',
      startingHeight: 0,
      minimumDisplayHeight: -100,
      maximumDisplayHeight: 1000,
      designer: userInformation.userID,
      designerName: userInformation.userName,
      signature: userInformation.userName,
      sectors: []
    }
    setSelectedEditorProfileBackup(JSON.parse(JSON.stringify(editorProfile)));
    handleUpdateSelectedProfile(editorProfile);
    toggleProfileOverview(true);
    toggleProfileDetails(true);
    setTab('profileEditor');

  }

  function handleSetProfileFilter(filter) {
    if (filter === 'All') setProfileFilter([]);
    else if (filter === 'Mine') setProfileFilter([{
      columnName: 'designerName',
      type: 'text',
      value: userInformation.userName,
      regex: userInformation.userName,
      valid: true
    }]);
    else if (filter === 'Open') setProfileFilter([{
      columnName: 'status',
      type: 'text',
      value: 'Des|Rev',
      regex: 'Des|Rev',
      valid: true
    }]);
    else setProfileFilter([{
      columnName: 'project',
      type: 'text',
      value: filter,
      regex: filter,
      valid: true
    }]);
  }

  function handleSetRaceFilter(filter) {
    if (filter === 'All') setRaceFilter([]);
    else setRaceFilter([{
      columnName: 'status',
      type: 'text',
      value: filter,
      regex: filter,
      valid: true
    }]);
  }

  function handleUpdateSelectedRaceParameter(key, value) {
    // console.log(key, value);
    if (['ridersPerTeam', 'category', 'recurringEvent'].includes(key))
      value = Number(value);
    if (key === 'recurringEvent')
      handleUpdateRecurringEvent(value);
    else {
      let race = structuredClone(selectedRace);
      race[key] = value;
      handleUpdateSelectedRace(race);
    }
  }

  function handleUpdateSelectedRace(race, saveRaceRequired = true) {
    setSelectedRace(race);
    setSaveRaceRequired(saveRaceRequired);

    if (userInformation !== null &&
      (race.status === 'Draft' || race.status === 'New' ||
        race.status === 'Planned'))
      setUserCanEditSelectedRace(true);
    else
      setUserCanEditSelectedRace(false);
  }

  function handleUpdateRecurringEvent(recurringEventId) {
    if (recurringEvents.some(re => re.id === recurringEventId)) {
      let recurringEventObject = recurringEvents.find(re => re.id === recurringEventId);
      handleUpdateSelectedRace({
        ...selectedRace,
        recurringEvent: recurringEventObject.name,
        ridersPerTeam: 'ridersPerTeam' in recurringEventObject ? recurringEventObject.ridersPerTeam : selectedRace.ridersPerTeam,
        raceName: 'currentName' in recurringEventObject ? recurringEventObject.currentName : recurringEventObject.name,
        description: 'description' in recurringEventObject ? recurringEventObject.description : selectedRace.description,
        category: 'c4fCategory' in recurringEventObject ? recurringEventObject.c4fCategory : selectedRace.category,        
        rulesetName: 'rulesetName' in recurringEventObject ? recurringEventObject.rulesetName : selectedRace.rulesetName
      });
    }

    else handleUpdateSelectedRace({ ...selectedRace, recurringEvent: '' });
  }

  // function handleUpdateRulesetName(rulesetName) {
  //   handleUpdateSelectedRace({
  //     ...selectedRace,
  //     rulesetName: rulesetName
  //   });
  // }

  function handleUpdateStage(stage) {
    if (stage.raceType !== 'TeamTimeTrial' && stage.stageBonificationType === 'TeamTimeTrial' ||
      stage.raceType !== 'IndividualTimeTrial' && stage.stageBonificationType === 'IndividualTimeTrial') {
      stage.stageBonificationType = 'Flat';
    }
    if (stage.raceType === 'TeamTimeTrial') {
      stage.stageBonificationType = 'TeamTimeTrial';
    }
    if (stage.raceType === 'IndividualTimeTrial') {
      stage.stageBonificationType = 'IndividualTimeTrial';
    }
    setSelectedStage(stage);
    handleUpdateSelectedRace({
      ...selectedRace,
      stages: selectedRace.stages.filter(s => s.id !== stage.id).concat([stage])
    })
  }

  function handleUpdateSelectedRaceEditionParameter(key, value) {
    if (['startingTime', 'minDivision', 'maxDivision'].includes(key))
      value = Number(value);
    let raceEdition = structuredClone(selectedRaceEdition);
    raceEdition[key] = value;
    handleUpdateRaceEdition(raceEdition);
  }

  function handleUpdateRaceEdition(raceEdition) {
    setSelectedRaceEdition(raceEdition);
    handleUpdateSelectedRace({
      ...selectedRace,
      raceEditions: selectedRace.raceEditions.filter(re => re.id !== raceEdition.id).concat([raceEdition])
    })
  }

  function handleSaveRaceChanges(race = null) {
    let objectToSave = race === null ? selectedRace : race;

    // populate race name and description on stage in case of 1dr
    if (objectToSave.stages.length === 1) {
      objectToSave = {
        ...objectToSave,
        stages: [{
          ...objectToSave.stages[0],
          name: objectToSave.raceName,
          description: objectToSave.description
        }]
      }
    }

    objectToSave = {
      ...objectToSave,
      stages: objectToSave.stages.sort(function (a, b) { return a.number - b.number })
    };

    let originalId = objectToSave.id;

    // verify ruleset fits to race type
    let ruleset = raceRulesets.find(rr => rr.name === objectToSave.rulesetName);
    if (ruleset.raceType === 'OneDayRace' && objectToSave.stages.length > 1) {
      raiseError('Technical Error', 0, 'Please use a ruleset for tours.');
      return;
    }
    if (ruleset.raceType === 'StageRace' && objectToSave.stages.length <= 1) {
      raiseError('Technical Error', 0, 'Please use a ruleset for one-day races.');
      return;
    }

    handleBackendRequest('PATCH', '/race/' + objectToSave.id, objectToSave, null,
      function (race) {
        handleUpdateSelectedRace(race, false);
        setSelectedRaceBackup(JSON.parse(JSON.stringify(race)));
        setRaces(races.filter(r => r.id !== originalId).concat([race]));
        doRefreshImage(Date.now());
      });

  }

  function withdrawPublishedRace(raceToWithdraw) {
    handleBackendRequest('POST', '/race/' + raceToWithdraw.id + '/withdraw', null, null,
      function (race) {
        setSelectedCalendarRace(race);
        setCalendarRaces(calendarRaces.filter(r => r.id !== race.id).concat([race]));
      });
  }

  function handleCancelRaceChanges() {
    handleUpdateSelectedRace(selectedRaceBackup, false);
    setSelectedStage(null);
    setSelectedRaceEdition(null);
  }

  function identifyRaceCountry() {
    if (selectedEditorProfile.sectors.length === 0) return;
    if (!selectedEditorProfile.sectors.some(s => 'latitude' in s)) return;

    axios.get('https://api.openweathermap.org/geo/1.0/reverse', {
      params: {
        lat: selectedEditorProfile.sectors[0].latitude,
        lon: selectedEditorProfile.sectors[0].longitude,
        limit: '1',
        appid: 'b172a5e2b0ed33a70df77c0213ac0be6',
      }
    }).then(result => {
      if (result.status === 200) {
        if (result.data.constructor === Array && result.data.length > 0) {
          handleUpdateSelectedProfile({ ...selectedEditorProfile, countryStart: result.data[0].country, countryFinish: result.data[0].country }, true, false);
        }
      }
    }).catch(e => {
      console.log(e);
    });
  }


  function addRace() {
    let newRace = {
      id: 'temp' + getNextCounterValue('editorCounter'),
      raceName: 'tbd',
      description: 'tbd',
      category: 1,
      ridersPerTeam: 8,
      status: 'New',
      recurringEvent: '',
      rulesetName: 'OneDayRaceStandard',
      stages: [
        {
          id: 'temp' + getNextCounterValue('editorCounter'),
          number: 1,
          name: 'tbd',
          description: 'tbd',
          raceType: 'Regular',
          stageType: 'FullStage',
          stageBonificationType: 'Flat',
          minuteTactStart: 1,
          profileCode: ''
        }
      ],
      raceEditions: [
        {
          id: 'temp' + getNextCounterValue('editorCounter'),
          startingDate: (new Date()).toISOString().substring(0, 10),
          startingTime: 10,
          minDivision: 1,
          maxDivision: 8
        }
      ]
    };
    handleUpdateSelectedRace(newRace);
  }

  function planRace() {
    // is admin
    if (!isAdmin()) {
      raiseError('Technical Error', 0, 'Only (calendar) admins can put races on the planned calendar');
      return;
    }
    if (selectedRace.status !== 'Draft') {
      raiseError('Technical Error', 0, 'Race is not in status Draft');
      return;
    }
    // race editions on same day?

    // save race
    handleSaveRaceChanges({
      ...selectedRace,
      status: 'Planned'
    })
  }

  function unplanRace() {
    // is admin
    if (!isAdmin()) {
      raiseError('Technical Error', 0, 'Only (calendar) admins can remove races from the planned calendar');
      return;
    }
    if (selectedRace.status !== 'Planned') {
      raiseError('Technical Error', 0, 'Race is not in planned calendar');
      return;
    }
    // save race
    handleSaveRaceChanges({
      ...selectedRace,
      status: 'Draft'
    })
  }

  function publishRace() {
    // is admin
    if (!isAdmin()) {
      raiseError('Technical Error', 0, 'Only (calendar) admins can publish races on the calendar');
      return;
    }
    // check all profiles set and approved    
    for (let i = 0; i < selectedRace.stages.length; i++) {
      let stage = selectedRace.stages[i];
      if (stage.raceType === 'RestDay') continue;
      if (!stage.profileCode || stage.profileCode === '') {
        raiseError('Technical Error', 0, 'Not all profiles in race are created.');
        return;
      }
      if (selectedRace.stages.length > 1) {
        if (!stage.profileStatus || stage.profileStatus !== 'Approved' && stage.profileStatus !== 'Review' && stage.profileStatus !== 'Archived') {
          raiseError('Technical Error', 0, 'For publishing race, all profiles in a stage race need to be in review, approved or archived');
          return;
        }
      }
      else {
        if (!'profileStatus' in stage || stage.profileStatus !== 'Approved' && stage.profileStatus !== 'Archived') {
          raiseError('Technical Error', 0, 'For publishing a one-day race, the profile needs to be approved');
          return;
        }
      }
    }
    // race editions on same day?

    // save race
    handleSaveRaceChanges({
      ...selectedRace,
      status: 'Published'
    })
  }

  function addStage() {
    let newStage = {
      id: 'temp' + getNextCounterValue('editorCounter'),
      number: selectedRace.stages.length + 1,
      name: 'tbd',
      description: 'tbd',
      raceType: 'Regular',
      stageType: 'FullStage',
      stageBonificationType: 'Flat',
      minuteTactStart: 1,
      profileCode: ''
    };
    setSelectedStage(newStage);
    handleUpdateSelectedRace({
      ...selectedRace,
      stages: selectedRace.stages.concat([newStage])
    });

  }

  function addRaceEdition() {
    let newRaceEdition = {
      id: 'temp' + getNextCounterValue('editorCounter'),
      startingDate: selectedRace.raceEditions.length > 0 ? selectedRace.raceEditions[0].startingDate : new Date(),
      startingTime: 10,
      minDivision: 1,
      maxDivision: 8
    };
    setSelectedRaceEdition(newRaceEdition);
    handleUpdateSelectedRace({
      ...selectedRace,
      raceEditions: selectedRace.raceEditions.concat([newRaceEdition])
    });
  }

  function deleteRace(race = null) {
    let raceToDelete = race === null ? selectedRace : race;
    handleBackendRequest('DELETE', '/race/' + raceToDelete.id, null, null,
      function () {
        setRaces(races.filter(r => r.id !== raceToDelete.id))
        setSelectedRace(null);
        setSelectedRaceBackup(null);
      });
  }

  function cloneRace() {
    handleUpdateSelectedRace({
      ...selectedRace,
      id: 'temp' + getNextCounterValue('editorCounter'),
      status: 'New'
    });
  }

  function editStage(stage) {
    setSelectedStage(stage);
  }

  function cloneStage(stage) {
    handleUpdateSelectedRace({
      ...selectedRace,
      stages: selectedRace.stages.concat([{
        ...stage,
        id: 'temp' + getNextCounterValue('editorCounter')
      }])
    });
  }

  function deleteStage(stage) {
    if (selectedRace.stages.length === 1) {
      raiseError('Technical Error', 0, 'Last stage of a race cannot be deleted.')
      return;
    }

    handleUpdateSelectedRace({
      ...selectedRace,
      stages: selectedRace.stages.filter(s => s.id !== stage.id)
    })
  }

  function editRaceEdition(raceEdition) {
    setSelectedRaceEdition(raceEdition);
  }

  function cloneRaceEdition(raceEdition) {
    handleUpdateSelectedRace({
      ...selectedRace,
      raceEditions: selectedRace.raceEditions.concat([{
        ...raceEdition,
        id: 'temp' + getNextCounterValue('editorCounter')
      }])
    });
  }

  function deleteRaceEdition(raceEdition) {
    if (selectedRace.raceEditions.length === 1) {
      raiseError('Technical Error', 0, 'Last edition of a race cannot be deleted.')
      return;
    }

    handleUpdateSelectedRace({
      ...selectedRace,
      raceEditions: selectedRace.raceEditions.filter(re => re.id !== raceEdition.id)
    })
  }

  function handleSaveEditorProfile(editorProfile = null) {
    let objectToSave = editorProfile === null ? selectedEditorProfile : editorProfile;
    let validationResult = validateProfile(objectToSave);

    if (!validationResult.result) {
      raiseError('Validation Error', 0, <>{validationResult.messages.map(m => <>{m}<br></br></>)}</>);
      return;
    }

    if (objectToSave.name === '') objectToSave.name = objectToSave.profileCode;

    handleBackendRequest('PATCH', '/profile/' + objectToSave.profileCode, objectToSave, null,
      function (profile) {
        setSelectedEditorProfileBackup(JSON.parse(JSON.stringify(profile)));
        handleUpdateSelectedProfile(profile, false);
        doRefreshImage(Date.now());
      });

  }

  function handleCancelSectorChange() {
    setSelectedSector(selectedEditorProfile.sectors[selectedSector.km - 1]);
    setDetailedAction('none');
  }

  function handleSetSector(nextSector = 0) {
    let currentSector = selectedSector.km;
    if (!isInteger(selectedSector.incline)) {
      raiseError('Technical Error', 0, 'Incline needs to be an integer.');
      return;
    }
    if (selectedSector.surface !== 'Asphalt' && selectedSector.bonification !== 'None') {
      raiseError('Technical Error', 0, 'Bonifications on cobbles are not (yet) possible.');
      return;
    }

    let sectors = selectedEditorProfile.sectors;
    sectors[selectedSector.km - 1] = { ...selectedSector, incline: parseInt(selectedSector.incline) };
    handleUpdateSelectedProfile({
      ...selectedEditorProfile,
      sectors: sectors
    });
    let newSector = Math.min(Math.max(1, currentSector + nextSector), sectors.length);
    if (nextSector !== 0) setSelectedSector({
      ...sectors[newSector - 1],
      km: newSector,
      label: 'label' in sectors[newSector - 1] ? sectors[newSector - 1].label : ''
    });
  }

  function handleSelectCalendarRace(race) {
    setSelectedCalendarRace(race);
    handleSelectCalendarStage(race.stages[0]);
  }

  function handleSelectCalendarStage(stage) {
    setSelectedCalendarStage(stage);
    if ('profileCode' in stage)
      loadCalendarProfile(stage.profileCode);
    else
      setSelectedCalendarProfile(null);
  }

  function mapSurface(surface) {
    switch (surface) {
      case 'VeryLightCobbles': return '*';
      case 'LightCobbles': return '**';
      case 'MediumCobbles': return '***';
      case 'RoughCobbles': return '****';
      case 'VeryRoughCobbles': return '*****';
      default: return '';
    }
  }

  function mapBonification(bonification) {
    switch (bonification) {
      case 'MountainCat4': return '4';
      case 'MountainCat3': return '3';
      case 'MountainCat2': return '2';
      case 'MountainCat1': return '1';
      case 'MountainCatHC': return 'HC';
      case 'IntermediateSprint': return 'S';
      case 'MountainCat4B': return '4B';
      case 'MountainCat3B': return '3B';
      case 'MountainCat2B': return '2B';
      case 'MountainCat1B': return '1B';
      case 'MountainCatHCB': return 'HCB';
      case 'IntermediateSprintB': return 'SB';
      case 'MountainCatHCC': return 'HCC';
      default: return '';
    }
  }

  function loadCalendarRaces() {
    handleBackendRequest('GET', '/race', null, { context: 'preview' },
      function (result) {
        setCalendarRaces(result);
      });

  }

  function loadRaces() {
    handleBackendRequest('GET', '/race', null, { context: 'editor' },
      function (result) {
        setRaces(result);
      });

  }

  function loadRace(race) {
    handleBackendRequest('GET', '/race/' + race.id, null, { context: 'editor' },
      function (result) {
        handleUpdateSelectedRace(result, false);
        setSelectedRaceBackup(JSON.parse(JSON.stringify(result)));
        setTab('raceEditor');
      });

  }

  function loadEditorProfiles(profileCode = null) {
    handleBackendRequest('GET', '/profile', null, profileCode ? { profileCode: profileCode } : null,
      function (result) {
        setEditorProfiles(result);
        if (profileCode) {
          setShowSearchProfileModal(false);
          handleSetProfileFilter('All');
        }
      });
  }

  function loadEditorProfile(editorProfile) {
    handleBackendRequest('GET', '/profile/' + editorProfile.profileCode, null, { context: 'editor' },
      function (result) {
        handleUpdateSelectedProfile(result, false, false);
        setSelectedEditorProfileBackup(JSON.parse(JSON.stringify(result)));
        if (!showProfileOverview) toggleProfileOverview(true);
        if (!showProfileDetails) toggleProfileDetails(true);
        toggleProfileMap(false);
      });

  }

  function loadCalendarProfile(profileCode) {
    handleBackendRequest('GET', '/profile/' + profileCode, null, { context: 'editor' }, setSelectedCalendarProfile);

  }

  useEffect(() => {
    loadEditorProfiles();
    loadRaces();
    loadCalendarRaces();
    addCounter('editorCounter');
    handleSetProfileFilter('Mine')
  }, []);

  return <><Container fluid className="m-1">
    <Row className="justify-content-center my-1">
      <ButtonGroup>
        <Button variant={(tab === 'profileEditor') ? 'primary' : 'outline-primary'} onClick={() => setTab('profileEditor')}>Profile Editor</Button>
        <Button variant={(tab === 'raceEditor') ? 'primary' : 'outline-primary'} onClick={() => setTab('raceEditor')}>Race Editor</Button>
        <Button variant={(tab === 'calendar') ? 'primary' : 'outline-primary'} onClick={() => setTab('calendar')}>Calendar Preview</Button>
        <Button variant={(tab === 'calendarChat') ? 'primary' : 'outline-primary'} onClick={() => setTab('calendarChat')}>Calendar Chat</Button>
        <Button variant={(tab === 'instructions') ? 'primary' : 'outline-primary'} disabled onClick={() => setTab('instructions')}>Instructions</Button>
      </ButtonGroup>
    </Row>
    {tab === 'profileEditor' ?
      <>
        <Row className="justify-content-center">
          <Col>
            <input type="file" id="gpxFile" accept=".gpx"
              onChange={(e) => readLocalFile(e.target.files[0], function (o) { parseGpx(o.target.result, e.target.files[0]); })}
              ref={gpxFile} style={{ display: 'none' }} />
            <input type="file" id="profileExcelFile" accept=".xlsx"
              onChange={(e) => readLocalFile(e.target.files[0], function () { parseProfileExcel(e.target.files[0]); })}
              ref={profileExcelFile} style={{ display: 'none' }} />
            <ButtonGroup>
              <Button size="sm" variant={showProfileList ? 'secondary' : 'outline-secondary'} onClick={() => toggleProfileList(!showProfileList)}>List</Button>
              <Button size="sm" variant={showProfileOverview ? 'secondary' : 'outline-secondary'} onClick={() => toggleProfileOverview(!showProfileOverview)}>Overview</Button>
              <Button size="sm" variant={showProfileDetails ? 'secondary' : 'outline-secondary'} onClick={() => toggleProfileDetails(!showProfileDetails)}>Details</Button>
              <DropdownButton as={ButtonGroup} size="sm" title={'Filter'}
                variant={'secondary'} onSelect={(filter, e) => handleSetProfileFilter(filter)}>
                <Dropdown.Item key={1} eventKey={'All'}>All</Dropdown.Item>
                <Dropdown.Item key={2} eventKey={'Mine'}>Mine</Dropdown.Item>
                <Dropdown.Item key={3} eventKey={'Open'}>Open</Dropdown.Item>
                <Dropdown.Item key={4} eventKey={'OneDayFantasy'}>Fantasy One-Days</Dropdown.Item>
                <Dropdown.Item key={5} eventKey={'OneDayReal'}>Real One-Days</Dropdown.Item>
                <Dropdown.Item key={6} eventKey={'GrandTour'}>Grand Tours</Dropdown.Item>
                <Dropdown.Item key={7} eventKey={'TourReal'}>Real Tours</Dropdown.Item>
                <Dropdown.Item key={8} eventKey={'WinterClassics'}>Winter Classics</Dropdown.Item>
                <Dropdown.Item key={9} eventKey={'NC'}>National Championships</Dropdown.Item>
              </DropdownButton>
              {selectedEditorProfile !== null && selectedEditorProfile.sectors.some(sector => 'latitude' in sector) ?
                <Button size="sm" variant={'warning'} onClick={() => toggleProfileMap(!showProfileMap)}>
                  {showProfileMap ? 'Map' : 'Profile'}
                </Button>
                :
                <Button size="sm" variant={'warning'} disabled>Profile</Button>
              }
              <>
                <DataCaptureModal title={'Search Archived Profile'}
                  data={[{ parameterName: 'ProfileCode', info: 'Wild card search for archived profiles, will automatically search for \'%profileCode%\'.' }]}
                  show={showSearchProfileModal}
                  callbackOK={(data) => loadEditorProfiles(data[0].parameterValue)}
                  callbackCancel={() => setShowSearchProfileModal(false)} />
                <Button size="sm" variant={'primary'} onClick={() => setShowSearchProfileModal(true)}>Search Profile</Button>
              </>
            </ButtonGroup>
            {selectedEditorProfile !== null && userCanEditSelectedProfile ?
              <>
                <ButtonGroup className="mx-1">
                  {saveProfileRequired || selectedEditorProfile.status === 'Draft' ?
                    <Button size="sm" variant={'success'} onClick={() => handleSaveEditorProfile()}>Save</Button>
                    :
                    <Button size="sm" variant={'outline-success'} disabled>Save</Button>
                  }
                  {saveProfileRequired && selectedEditorProfile.status !== 'Draft' ?
                    <Button size="sm" variant={'danger'} onClick={() => handleRevertProfileChanges()}>Cancel</Button>
                    :
                    <Button size="sm" variant={'outline-danger'} disabled>Cancel</Button>
                  }
                  {saveProfileRequired ?
                    <>
                      {selectedEditorProfile.status === 'Design' ?
                        <Button variant="outline-success" size="sm" disabled>Start Review</Button>
                        : null}
                      {selectedEditorProfile.status === 'Review' && isAdmin() ?
                        <Button variant="outline-success" size="sm" disabled>Approve</Button>
                        : null}
                    </>
                    :
                    <>
                      {selectedEditorProfile.status === 'Design' ?
                        <Button variant="success" size="sm" onClick={() => startProfileReview()}>Start Review</Button>
                        : null}
                      {selectedEditorProfile.status === 'Review' && isAdmin() ?
                        <Button variant="success" size="sm" onClick={() => approveProfile()}>Approve</Button>
                        : null}
                      {selectedEditorProfile.status === 'Approved' && isAdmin() ?
                        <Button variant="success" size="sm" onClick={() => reopenProfile()}>Reopen</Button>
                        : null}
                      {(selectedEditorProfile.status === 'Design' || selectedEditorProfile.status === 'Review') && userInformation.userID === selectedEditorProfile.designer ?
                        <Button variant="danger" size="sm" onClick={() => discardProfile()}>Discard Profile</Button>
                        : null}
                      {selectedEditorProfile.status === 'ToBeDeleted' ?
                        <Button variant="success" size="sm" onClick={() => restoreProfile()}>Restore Profile</Button>
                        : null}
                      {selectedEditorProfile.status === 'ToBeDeleted' && isAdmin() ?
                        <Button variant="danger" size="sm" onClick={() => deleteProfile()}>Delete Profile</Button>
                        : null}
                    </>
                  }
                </ButtonGroup>
              </>
              : null
            }
            {selectedEditorProfile !== null && !saveProfileRequired ?
              <>
                <DataCaptureModal title={'New Profile Designer'}
                  data={[{ parameterName: 'Team', info: 'Team Name to which the designer should be changed to.' }]}
                  show={showDesignerNameChangeModal}
                  callbackOK={(data) => executeChangeDesigner(data)}
                  callbackCancel={() => setShowDesignerNameChangeModal(false)} />
                <ButtonGroup className="mx-1">
                  <Button variant="primary" size="sm" onClick={() => cloneProfile()}
                    disabled={selectedEditorProfile.status !== 'Approved' && selectedEditorProfile.status !== 'Archived'}>Clone Profile</Button>
                  {isAdmin() ?
                    <Button variant="secondary" size="sm" onClick={() => initiateChangeDesigner()}
                      disabled={selectedEditorProfile.status !== 'Design' && selectedEditorProfile.status !== 'Review'}>Change Designer</Button>
                    : null}
                </ButtonGroup>
              </>
              : null}
          </Col>
        </Row>
        {showProfileList ?
          <Row className="justify-content-center p-1">
            <Col>
              <C4FSimpleTable key={'editorProfiles'}
                highlightCriteriaKey={'profileCode'}
                highlightCriteriaValue={selectedEditorProfile !== null ? selectedEditorProfile.profileCode : null}
                initialSortingColumn={'profileCode'}
                initialSortingAscending={true}
                addRecord={createNewProfile}
                refreshTable={loadEditorProfiles}
                filters={profileFilter}
                data={editorProfiles.map(ep => ({
                  ...ep,
                  profileCodeTruncated: truncateString(ep.profileCode, 20),
                  project: ep.project ?? '',
                  nameTruncated: truncateString(ep.name, 28),
                  designerNameTruncated: truncateString(ep.designerName, 18),
                  edit: '\u270E'
                }))}
                rowMetadata={[
                    { columnName: 'profileCodeTruncated', columnDescription: 'ProfileCode', cellClickEvent: loadEditorProfile },
                    { columnName: 'nameTruncated', columnDescription: 'Name', cellClickEvent: loadEditorProfile },
                    { columnName: 'status', columnDescription: 'Status' },
                    { columnName: 'designerNameTruncated', columnDescription: 'Designer' },
                    { columnName: 'project', columnDescription: 'Project' },
                    { columnName: 'length', columnDescription: 'Length' },
                    { columnName: 'elevationGain', columnDescription: 'hm' },
                    { columnName: 'lastUpdate', columnDescription: 'Updated' }
                  ]}
              />
            </Col>
          </Row>
          : null}
        {selectedEditorProfile !== null ?
          <>
            {showProfileOverview ?
              <Row className="justify-content-center">
                <Col className="col-4 border border-secondary">
                  <InputGroup size="sm" className="mt-1">
                    <C4FInfoButton size="sm" title={'ProfileCode'} text={'unique identifier for profile, always lower case (automatically updated if not)'} />
                    <Form.Control disabled type={'text'} value={'Profile Code'} />
                    <Form.Control disabled={selectedEditorProfile.status !== 'Draft'}
                      type={'text'} value={selectedEditorProfile.profileCode}
                      onChange={(e) => handleUpdateSelectedProfile({ ...selectedEditorProfile, profileCode: e.target.value }, true, false)} />
                  </InputGroup>
                  <InputGroup size="sm" className="mt-1">
                    <C4FInfoButton size="sm" title={'Status'} text={'Status of the profile: Design (creator can edit profile), Review (creator and admins can edit profile), Approved (no changes possible, can be used in the race calendar now), ToBeDeleted (profile is ready for deletion by admins)'} />
                    <Form.Control disabled type={'text'} value={'Status'} />
                    <Form.Control type={'text'} disabled value={selectedEditorProfile.status} />
                  </InputGroup>
                  <InputGroup size="sm" className="mt-1">
                    <C4FInfoButton size="sm" title={'Project'} text={'grouping multiple profiles for easier search and filtering, e.g. GrandTour'} />
                    <Form.Control disabled type={'text'} value={'Project'} />
                    <DropdownButton size="sm" variant={'outline-secondary'}
                      title={selectedEditorProfile.project}
                      onSelect={(project, e) => handleUpdateSelectedProfile({ ...selectedEditorProfile, project: project }, true, false)} >
                      {projects.map(project => (
                        <Dropdown.Item eventKey={project}>{project}</Dropdown.Item>
                      ))}
                    </DropdownButton>
                  </InputGroup>
                  <InputGroup size="sm" className="mt-1">
                    <C4FInfoButton size="sm" title={'Name'} text={'Name will be automatically set to: ProfileCode, if the profile is not used yet in any race, or name defined in race editor once it\'s in use'} />
                    <Form.Control disabled type={'text'} value={'Name'} />
                    <Form.Control type={'text'} value={selectedEditorProfile.name} disabled />
                  </InputGroup>
                  <InputGroup size="sm" className="mt-1">
                    <C4FInfoButton size="sm" title={'Description'} text={'description of the race, not used anywhere else'} />
                    <Form.Control disabled type={'text'} value={'Description'} />
                    <Form.Control type={'text'} value={selectedEditorProfile.description}
                      onChange={(e) => handleUpdateSelectedProfile({ ...selectedEditorProfile, description: e.target.value }, true, false)} />
                  </InputGroup>
                  <InputGroup size="sm" className="mt-1">
                    <C4FInfoButton size="sm" title={'Designer'} text={'Signature of the designer, used in the profile picture'} />
                    <Form.Control disabled type={'text'} value={'Designer'} />
                    <Form.Control type={'text'} value={selectedEditorProfile.signature}
                      onChange={(e) => handleUpdateSelectedProfile({ ...selectedEditorProfile, signature: e.target.value }, true, false)} />
                    <Form.Control type={'text'} disabled value={selectedEditorProfile.designerName} />
                  </InputGroup>
                  <InputGroup size="sm" className="mt-1">
                    <C4FInfoButton size="sm" title={'Altitude Start'} text={'Altitude at the beginning of the race, used for generating profile picture'} />
                    <Form.Control disabled type={'text'} value={'Altitude Start'} />
                    <Form.Control type={'text'} value={selectedEditorProfile.startingHeight}
                      onChange={(e) => handleSetStartingHeight(e.target.value)} />
                  </InputGroup>
                  <InputGroup size="sm" className="mt-1">
                    <C4FInfoButton size="sm" title={'Profile Picture'} text={'Minimum and maximum altitude shown on the profile picture, automatically set when saving profile, but can be overridden'} />
                    <Form.Control disabled type={'text'} value={'Profile Picture'} />
                    <Form.Control type={'text'} value={selectedEditorProfile.minimumDisplayHeight}
                      onChange={(e) => handleSetMinimumDisplayHeight(e.target.value)} />
                    <Form.Control type={'text'} value={selectedEditorProfile.maximumDisplayHeight}
                      onChange={(e) => handleSetMaximumDisplayHeight(e.target.value)} />
                  </InputGroup>
                  <InputGroup size="sm" className="my-1">
                    <C4FInfoButton size="sm" title={'Country'} text={'Country at start and end of the race, used for profile picture'} />
                    <Form.Control disabled type={'text'} value={'Country'} />
                    <DropdownButton size="sm" variant={'outline-secondary'}
                      // title={countries.find(country => country.countryCode === selectedEditorProfile.countryStart).countryCode}
                      title={getUnicodeFlag(selectedEditorProfile.countryStart) + ' ' + selectedEditorProfile.countryStart}
                      onSelect={(countryCode, e) => handleUpdateSelectedProfile({ ...selectedEditorProfile, countryStart: countryCode }, true, false)} >
                      {countries.map((country) => (
                        <Dropdown.Item eventKey={country.countryCode}>
                          {getUnicodeFlag(country.countryCode) + ' ' + country.country}
                        </Dropdown.Item>
                      ))}
                    </DropdownButton>
                    <DropdownButton size="sm" variant={'outline-secondary'}
                      title={getUnicodeFlag(selectedEditorProfile.countryFinish) + ' ' + selectedEditorProfile.countryFinish}
                      onSelect={(countryCode, e) => handleUpdateSelectedProfile({ ...selectedEditorProfile, countryFinish: countryCode }, true, false)} >
                      {countries.map((country) => (
                        <Dropdown.Item eventKey={country.countryCode}>
                          {getUnicodeFlag(country.countryCode) + ' ' + country.country}
                        </Dropdown.Item>
                      ))}
                    </DropdownButton>
                    <Button size="sm" variant="outline-success" onClick={() => identifyRaceCountry()}>{'\uD83E\uDE84'}</Button>
                  </InputGroup>
                </Col>
                {showProfileMap ?
                  <Col className="col-8 border border-secondary">
                    {selectedEditorProfile.sectors.length > 0 ?
                      <Map center={getProfileCenter()} zoom={8} minZoom={6} maxZoom={13} width={600} height={400}>
                        <ZoomControl />
                        <Line coordsArray={selectedEditorProfile.sectors.map(sector => ([sector.latitude, sector.longitude]))} />
                      </Map>
                      : null}
                  </Col>
                  :
                  <Col className="col-8 border border-secondary">
                    {selectedEditorProfile.status !== 'Draft' ?
                      <Container className="border border-secondary m-0 p-0" style={{ maxWidth: 746, maxHeight: 240, backgroundColor: 'rgba(251, 253, 255, 1)' }}>
                        <img style={{ maxHeight: "100%", maxWidth: "100%" }}
                          alt="Race profile will be shown here."
                          src={config.DIR_PROFILES + selectedEditorProfile.profileCode + ".png?" + refreshImage} />
                      </Container>
                      :
                      <h5>Profile picture will only be available after the first save</h5>
                    }
                  </Col>
                }
              </Row>
              : null}
            {showProfileDetails ?
              <Row className="justify-content-center" style={{ height: '1500px' }}>
                <Col className="col-8 border border-secondary">
                  <ButtonGroup className="my-1">
                    {saveProfileRequired || selectedEditorProfile.status === 'Draft' ?
                      <Button size="sm" variant={'success'} onClick={() => handleSaveEditorProfile()}>Save</Button>
                      :
                      <Button size="sm" variant={'outline-success'} disabled>Save</Button>
                    }
                    {saveProfileRequired && selectedEditorProfile.status !== 'Draft' ?
                      <Button size="sm" variant={'danger'} onClick={() => handleRevertProfileChanges()}>Cancel</Button>
                      :
                      <Button size="sm" variant={'outline-danger'} disabled>Cancel</Button>
                    }
                  </ButtonGroup>
                  <ButtonGroup className="m-1">
                    {selectedEditorProfile.sectors.length === 0 ?
                      <>
                        <Button variant="primary" size="sm" onClick={() => gpxFile.current.click()}>Create GPX Profile</Button>
                        <Button variant="primary" size="sm" onClick={() => addSector(0)}>Create Manual Profile</Button>
                        {profileClipboard.length > 0 ?
                          <Button variant="primary" size="sm" onClick={() => pasteFromCliboard()}>Paste From Clipboard ({profileClipboard.length})</Button>
                          :
                          <Button variant="primary" size="sm" disabled>Paste From Clipboard</Button>
                        }
                      </>
                      :
                      (saveProfileRequired || !userCanEditSelectedProfile || !['Draft', 'Design', 'Review'].includes(selectedEditorProfile.status) ?
                        <>
                          <Button variant="outline-primary" size="sm" disabled>Insert GPX Section</Button>
                          <Button variant="outline-primary" size="sm" disabled>Insert Circuit</Button>
                          <Button variant="outline-primary" size="sm" disabled>Insert From Clipboard</Button>
                          <Button variant="primary" size="sm" onClick={() => exportProfileExcel(selectedEditorProfile)}>Export</Button>
                          <Button variant="outline-primary" size="sm" disabled>Import</Button>
                        </>
                        :
                        <>
                          <Button variant="primary" size="sm" disabled>Insert GPX Section</Button>
                          <Button variant="primary" size="sm" onClick={() => setDetailedAction('insertCircuit')}>Insert Circuit</Button>
                          <Button variant="primary" size="sm" onClick={() => setDetailedAction('clipboard')}>Copy, Paste & Delete</Button>
                          <Button variant="primary" size="sm" onClick={() => exportProfileExcel(selectedEditorProfile)}>Export</Button>
                          <Button variant="primary" size="sm" onClick={() => profileExcelFile.current.click()}>Import</Button>                          
                        </>
                      )
                    }
                  </ButtonGroup>
                  <C4FSimpleTable key={'editorProfileSectors'}
                    maxHeight={1400}
                    highlightCriteriaKey={'km'}
                    highlightCriteriaValue={selectedSector !== null ? selectedSector.km : null}
                    initialSortingColumn={'index'}
                    initialSortingAscending={true}
                    hideColumnVisibility={true}
                    data={selectedEditorProfile.sectors.map((sector, index) => ({
                      ...sector,
                      km: index + 1,
                      mappedSurface: mapSurface(sector.surface),
                      mappedBonification: mapBonification(sector.bonification),
                      label: 'label' in sector ? sector.label : '',
                      edit: '\u270E',
                      clone: '\u2398',
                      delete: '\u2715'
                    }))}
                    rowMetadata={[
                      { columnName: 'km', columnDescription: 'km' },
                      { columnName: 'incline', columnDescription: 'Incline %' },
                      { columnName: 'mappedSurface', columnDescription: 'Surface' },
                      { columnName: 'height', columnDescription: 'Height C4F' },
                      { columnName: 'heightGPX', columnDescription: 'Height GPX' },
                      { columnName: 'mappedBonification', columnDescription: 'Bon.' },
                      { columnName: 'label', columnDescription: 'Label' },
                      { columnName: 'edit', columnDescription: '\u270E', columnType: 'button', cellClickEvent: userCanEditSelectedProfile ? editSector : null, className: 'py-0 btn-success' },
                      { columnName: 'clone', columnDescription: '\u2398', columnType: 'button', cellClickEvent: userCanEditSelectedProfile ? cloneSector : null, className: 'py-0 btn-warning' },
                      { columnName: 'delete', columnDescription: '\u2715', columnType: 'button', cellClickEvent: userCanEditSelectedProfile ? deleteSector : null, className: 'py-0 btn-danger' }
                    ]}
                  />

                </Col>
                <Col className="border border-secondary">
                  {detailedAction === 'editSector' && selectedSector !== null ?
                    <>
                      <ButtonGroup className="mt-1">
                        <Button size="sm" variant={'success'} onClick={() => handleSetSector(1)}>OK + next</Button>
                        <Button size="sm" variant={'success'} onClick={() => handleSetSector(-1)}>OK + previous</Button>
                        <Button size="sm" variant={'danger'} onClick={() => handleCancelSectorChange(selectedEditorProfile.sectors[selectedSector.km - 1])}>Cancel</Button>
                      </ButtonGroup>
                      <InputGroup size="sm" className="mt-1">
                        <Form.Control size="sm" type={'text'} disabled value={'km'} />
                        <Form.Control size="sm" type={'text'} disabled value={selectedSector.km} />
                      </InputGroup>
                      <InputGroup size="sm" className="mt-1">
                        <C4FInfoButton size="sm" title={'Profile Height'} text={'calculated height based on starting height and profile'} />
                        <Form.Control size="sm" type={'text'} disabled value={'Profile Height'} />
                        <Form.Control type={'text'} disabled value={selectedSector.height} />
                      </InputGroup>
                      <InputGroup size="sm" className="mt-1">
                        <C4FInfoButton size="sm" title={'GPX Height'} text={'height provided by GPX file'} />
                        <Form.Control size="sm" type={'text'} disabled value={'GPX Height'} />
                        <Form.Control type={'text'} disabled value={selectedSector.heightGPX} />
                      </InputGroup>
                      <InputGroup size="sm" className="mt-1">
                        <C4FInfoButton size="sm" title={'Incline'} text={'Incline at current km'} />
                        <Form.Control size="sm" type={'text'} disabled value={'Incline'} />
                        <Form.Control type={'text'} value={selectedSector.incline} onChange={(e) => setSelectedSector({ ...selectedSector, incline: e.target.value })} />
                      </InputGroup>
                      <InputGroup size="sm" className="mt-1">
                        <C4FInfoButton size="sm" title={'Surface'} text={'Road surface, asphalt or * to ***** cobbles'} />
                        <Form.Control size="sm" type={'text'} disabled value={'Surface'} />
                        <DropdownButton size="sm"
                          title={selectedSector.surface}
                          variant={'outline-secondary'}
                          onSelect={(newValue, e) => setSelectedSector({ ...selectedSector, surface: newValue })}>
                          {['Asphalt', 'VeryLightCobbles', 'LightCobbles', 'MediumCobbles', 'RoughCobbles', 'VeryRoughCobbles'].map(surface =>
                            <Dropdown.Item key={surface} eventKey={surface}>{surface}</Dropdown.Item>)
                          }
                        </DropdownButton>
                      </InputGroup>
                      <InputGroup size="sm" className="mt-1">
                        <C4FInfoButton size="sm" title={'Bonification'} text={'Intermediate at current km (sprint or mountain prize)'} />
                        <Form.Control size="sm" type={'text'} disabled value={'Bonification'} />
                        {selectedEditorProfile.project === 'GrandTour' ?
                          <DropdownButton size="sm"
                            title={selectedSector.bonification}
                            variant={'outline-secondary'}
                            onSelect={(newValue, e) => setSelectedSector({ ...selectedSector, bonification: newValue })}>
                            {['None', 'MountainCatHC', 'MountainCat1', 'MountainCat2', 'MountainCat3', 'MountainCat4','IntermediateSprint','MountainCatHCB', 'MountainCat1B', 'MountainCat2B', 'MountainCat3B', 'MountainCat4B','IntermediateSprintB', 'MountainCatHCC'].map(bonification =>
                              <Dropdown.Item key={bonification} eventKey={bonification}>{bonification}</Dropdown.Item>)
                            }
                          </DropdownButton>
                          :
                          <DropdownButton size="sm"
                          title={selectedSector.bonification}
                          variant={'outline-secondary'}
                          onSelect={(newValue, e) => setSelectedSector({ ...selectedSector, bonification: newValue })}>
                          {['None', 'MountainCatHC', 'MountainCat1', 'MountainCat2', 'MountainCat3', 'MountainCat4','IntermediateSprint'].map(bonification =>
                            <Dropdown.Item key={bonification} eventKey={bonification}>{bonification}</Dropdown.Item>)
                          }
                          </DropdownButton>
                        }
                      </InputGroup>
                      <InputGroup size="sm" className="mt-1">
                        <C4FInfoButton size="sm" title={'Label'} text={'Text to be shown in the profile at this km'} />
                        <Form.Control size="sm" type={'text'} disabled value={'Label'} />
                        <Form.Control type={'text'} value={selectedSector.label} onChange={(e) => setSelectedSector({ ...selectedSector, label: e.target.value })} />
                      </InputGroup>
                      <InputGroup size="sm" className="mt-1">
                        <C4FInfoButton size="sm" title={'Latitude'} text={'Latitude taken from GPX (not editable)'} />
                        <Form.Control size="sm" type={'text'} disabled value={'Latitude'} />
                        <Form.Control type={'text'} disabled value={selectedSector.latitude} />
                      </InputGroup>
                      <InputGroup size="sm" className="mt-1">
                        <C4FInfoButton size="sm" title={'Longitude'} text={'Longitude taken from GPX (not editable)'} />
                        <Form.Control size="sm" type={'text'} disabled value={'Longitude'} />
                        <Form.Control type={'text'} disabled value={selectedSector.longitude} />
                      </InputGroup>
                    </>
                    :
                    null}
                  {detailedAction === 'insertCircuit' ?
                    <>
                      <ButtonGroup>
                        {saveProfileRequired ?
                          <Button size="sm" variant={'success'} disabled>Add laps</Button>
                          :
                          <Button size="sm" variant={'success'} onClick={() => insertCircuit()}>Add laps</Button>
                        }
                      </ButtonGroup>
                      <InputGroup>
                        <C4FInfoButton title={'From km'} text={'km, where circuit to be duplicated starts'} />
                        <InputGroup.Text>From km</InputGroup.Text>
                        <Form.Control type={'text'} value={circuitFrom} onChange={(e) => setCircuitFrom(e.target.value)} />
                      </InputGroup>
                      <InputGroup>
                        <C4FInfoButton title={'To km'} text={'km, where circuit to be duplicated ends (including this km)'} />
                        <InputGroup.Text>To km</InputGroup.Text>
                        <Form.Control type={'text'} value={circuitTo} onChange={(e) => setCircuitTo(e.target.value)} />
                      </InputGroup>
                      <InputGroup>
                        <C4FInfoButton title={'Additional laps'} text={'Number of laps of the circuit to be added'} />
                        <InputGroup.Text>Additional laps</InputGroup.Text>
                        <Form.Control type={'text'} value={circuitLaps} onChange={(e) => setCircuitLaps(e.target.value)} />
                      </InputGroup>
                      <InputGroup>
                        <C4FInfoButton title={'Insert after'} text={'Position after which the circuit has to be added'} />
                        <InputGroup.Text>Insert after</InputGroup.Text>
                        <Form.Control type={'text'} value={circuitInsertAfter} onChange={(e) => setCircuitInsertAfter(e.target.value)} />
                      </InputGroup>
                      {saveProfileRequired ?
                        <Alert size="sm" variant={'warning'} >In order to correctly calculate heights, please save before adding another circuit.</Alert>
                        : null}
                    </>
                    : null}
                  {detailedAction === 'clipboard' ?
                    <>
                      <ButtonGroup>
                        {saveProfileRequired ?
                          <>
                            <Button size="sm" variant={'primary'} disabled>Copy</Button>
                            <Button size="sm" variant={'success'} disabled>Paste</Button>
                            <Button size="sm" variant={'danger'} disabled>Delete</Button>
                          </>
                          :
                          <>
                            <Button size="sm" variant={'primary'} onClick={() => copyToCliboard()}>Copy</Button>
                            {profileClipboard.length > 0 ?
                              <Button size="sm" variant={'success'} onClick={() => pasteFromCliboard()}>Paste ({profileClipboard.length})</Button>
                              :
                              <Button size="sm" variant={'success'} disabled>Paste</Button>
                            }
                            <Button size="sm" variant={'danger'} onClick={() => deleteSectors()}>Cut</Button>
                          </>
                        }
                      </ButtonGroup>
                      <InputGroup>
                        <C4FInfoButton title={'From km'} text={'km, where section to be copied starts'} />
                        <InputGroup.Text>From km</InputGroup.Text>
                        <Form.Control type={'text'} value={circuitFrom} onChange={(e) => setCircuitFrom(e.target.value)} />
                      </InputGroup>
                      <InputGroup>
                        <C4FInfoButton title={'To km'} text={'km, where section to be copied ends (including this km)'} />
                        <InputGroup.Text>To km</InputGroup.Text>
                        <Form.Control type={'text'} value={circuitTo} onChange={(e) => setCircuitTo(e.target.value)} />
                      </InputGroup>
                      {profileClipboard.length > 0 ?
                        <InputGroup>
                          <C4FInfoButton title={'Insert after'} text={'Position after which the section has to be added'} />
                          <InputGroup.Text>Insert after</InputGroup.Text>
                          <Form.Control type={'text'} value={circuitInsertAfter} onChange={(e) => setCircuitInsertAfter(e.target.value)} />
                        </InputGroup>
                        : null}
                      {saveProfileRequired ?
                        <Alert size="sm" variant={'warning'} >In order to correctly calculate heights, please save before pasting another section.</Alert>
                        : null}
                    </>
                    : null}
                </Col>
              </Row>
              : null}
          </>
          : null}
      </>
      : null}
    {tab === 'raceEditor' ?
      <>
        <Row className="justify-content-center">
          <Col>
            {/* <input type="file" id="gpxInputFile" accept=".gpx"
              onChange={(e) => readLocalFile(e.target.files[0], function (e) { parseGpx(e.target.result); })}
              ref={gpxFile} style={{ display: 'none' }} /> */}
            <ButtonGroup>
              {/* <Button size="sm" variant={showRaceList ? 'secondary' : 'outline-secondary'} onClick={() => toggleRaceList(!showRaceList)}>List</Button>
              <Button size="sm" variant={showRaceDetails ? 'secondary' : 'outline-secondary'} onClick={() => toggleRaceDetails(!showRaceDetails)}>Details</Button>
              <Button size="sm" variant={showRaceStages ? 'secondary' : 'outline-secondary'} onClick={() => toggleRaceStages(!showRaceStages)}>Stages</Button> */}
              <Button size="sm" variant={showRaceEditions ? 'secondary' : 'outline-secondary'} onClick={() => toggleRaceEditions(!showRaceEditions)}>Editions</Button>
              <DropdownButton as={ButtonGroup} size="sm" title={'Filter'}
                variant={'secondary'} onSelect={(filter, e) => handleSetRaceFilter(filter)}>
                <Dropdown.Item key={1} eventKey={'All'}>All</Dropdown.Item>
                <Dropdown.Item key={2} eventKey={'Draft'}>Draft</Dropdown.Item>
                <Dropdown.Item key={3} eventKey={'Planned'}>Planned</Dropdown.Item>
                <Dropdown.Item key={4} eventKey={'Published'}>Published</Dropdown.Item>
              </DropdownButton>
            </ButtonGroup>
            {selectedRace ?
              <ButtonGroup className="mx-1">
                {userCanEditSelectedRace ?
                  (saveRaceRequired ?
                    <>
                      <Button size="sm" variant={'success'} onClick={() => handleSaveRaceChanges()}>Save</Button>
                      <Button size="sm" variant={'danger'} onClick={() => handleCancelRaceChanges(races.find(r => r.id === selectedRace.id))}>Cancel</Button>
                      <Button size="sm" variant={'outline-primary'} disabled>Clone</Button>
                    </>
                    :
                    <>
                      <Button size="sm" variant={'outline-success'} disabled>Save</Button>
                      <Button size="sm" variant={'outline-danger'} disabled>Cancel</Button>
                      <Button size="sm" variant={'primary'} onClick={() => cloneRace()}>Clone</Button>
                    </>
                  )
                  :
                  <>
                    <Button size="sm" variant={'danger'} disabled>Readonly</Button>
                    <Button size="sm" variant={'warning'} onClick={() => cloneRace()}>Clone</Button>
                  </>
                }
                {selectedRace.status === 'Draft' && !saveRaceRequired ?
                  <Button size="sm" variant={'success'} onClick={() => planRace()}>To Planned Calendar</Button>
                  : null}
                {selectedRace.status === 'Planned' && !saveRaceRequired ?
                  <>
                    <Button size="sm" variant={'warning'} onClick={() => unplanRace()}>Back to Draft</Button>                    
                    <Button size="sm" variant={'success'} onClick={() => publishRace()}>Publish</Button>
                  </>
                  : null}
              </ButtonGroup>
              : null}
          </Col>
        </Row>
        <Row className="mt-1 py-1 border border-secondary">
          {showRaceList ?
            <Col className="col-7">
              <h5>Races</h5>
              <C4FSimpleTable key={'races'}
                initialSortingColumn={'startingDate'}
                initialSortingAscending={false}
                hideColumnVisibility={true}
                highlightCriteriaKey={'id'}
                highlightCriteriaValue={selectedRace !== null ? selectedRace.id : null}
                filters={raceFilter}
                refreshTable={loadRaces}
                addRecord={saveRaceRequired ? null : addRace}
                data={races.map(race => ({
                  ...race,
                  raceNameTruncated: truncateString(race.raceName, 25),
                  descriptionTruncated: truncateString(race.description, 20),
                  edit: '\u270E',
                  delete: '\u2715'
                }))}
                rowMetadata={
                  [
                    { columnName: 'id', columnDescription: 'ID', cellClickEvent: saveRaceRequired ? null : loadRace },
                    { columnName: 'raceNameTruncated', columnDescription: 'Name', cellClickEvent: saveRaceRequired ? null : loadRace },
                    { columnName: 'startingDate', columnDescription: 'Date' },
                    { columnName: 'status', columnDescription: 'Status' },
                    { columnName: 'category', columnDescription: 'Cat.' },
                    { columnName: 'ridersPerTeam', columnDescription: 'Riders' },
                    { columnName: 'recurringEvent', columnDescription: 'Event' },
                    { columnName: 'lastUpdate', columnDescription: 'Updated' }
                  ]
                    .concat(isAdmin() ?
                      [{ columnName: 'delete', columnDescription: '\u2715', columnType: 'button', cellClickEvent: saveRaceRequired ? null : deleteRace, className: 'py-0 btn-danger' }] : [])
                }
              />
            </Col>
            : null}
          {selectedRace !== null && showRaceDetails ?
            <Col className="col-5">
              <h5>Race Details</h5>
              <InputGroup size="sm">
                <InputGroup.Text>ID {selectedRace.id}</InputGroup.Text>
                <InputGroup.Text>{selectedRace.stages.length > 1 ? 'StageRace' : 'OneDayRace'}</InputGroup.Text>
                <InputGroup.Text>Status {selectedRace.status}</InputGroup.Text>                
              </InputGroup>
              <C4FSimpleTextField className="mt-1"
                info={'Name of the race (tour name or race name for one-day races)'}
                key={'raceName'}
                name={'raceName'}
                displayName={'Name'}
                value={selectedRace.raceName}
                updateMethod={handleUpdateSelectedRaceParameter} />
              <C4FSimpleTextField className="mt-1"
                info={'Description of the race for the calendar overview'}
                key={'description'}
                name={'description'}
                displayName={'Description'}
                value={selectedRace.description}
                updateMethod={handleUpdateSelectedRaceParameter} />
              <C4FReferenceDataSelection className="mt-1"
                info={'C4F category of the race (1 .. 6)'}
                key={'category'}
                name={'category'}                                    
                displayName={'Category'}
                value={selectedRace.category}
                referenceDataValues={['1', '2', '3', '4', '5', '6']}
                updateMethod={handleUpdateSelectedRaceParameter} />
              <C4FReferenceDataSelection className="mt-1"
                info={'Number of riders per participating team for this race'}
                key={'ridersPerTeam'}
                name={'ridersPerTeam'}
                displayName={'Riders per Team'}
                value={selectedRace.ridersPerTeam}
                referenceDataValues={['2', '3', '4', '5', '6', '7', '8', '9']}
                updateMethod={handleUpdateSelectedRaceParameter} />
              <C4FReferenceDataSelection className="mt-1"
                info={'Name of recurring event, used to link previous editions of the race, even if the name changes meanwhile (e.g. Het Volk became Het Nieuwsblad)'}
                useFilter={true}
                key={'recurringEvent'}
                name={'recurringEvent'}                                    
                displayName={'Event'}
                value={selectedRace.recurringEvent}
                referenceDataValues={[{ id: null, name: '' }].concat(recurringEvents).map(re => ({key: re.id, value: re.name}))}
                updateMethod={handleUpdateSelectedRaceParameter} />
              <C4FReferenceDataSelection className="mt-1"
                info={'Name of the ruleset, which defines points and prizes for intermediates, final sprints, and in case of tours for daily and tour rewards'}
                key={'rulesetName'}
                name={'rulesetName'}                                    
                displayName={'Ruleset'}
                value={selectedRace.rulesetName}
                referenceDataValues={raceRulesets.map(rr => rr.name)}
                updateMethod={handleUpdateSelectedRaceParameter} />


              {/* <InputGroup className="mt-1" size="sm">
                <C4FInfoButton title={'Name'} text={'Name of the race (tour name or race name for one-day races)'} />
                <InputGroup.Text>Name</InputGroup.Text>
                <Form.Control type={'text'} value={selectedRace.raceName}
                  onChange={(e) => handleUpdateSelectedRace({ ...selectedRace, raceName: e.target.value })} />
              </InputGroup>
              <InputGroup className="mt-1" size="sm">
                <C4FInfoButton title={'Description'} text={'Description of the race for the calendar overview'} />
                <InputGroup.Text>Description</InputGroup.Text>
                <Form.Control type={'text'} value={selectedRace.description}
                  onChange={(e) => handleUpdateSelectedRace({ ...selectedRace, description: e.target.value })} />
              </InputGroup>
              <InputGroup className="mt-1" size="sm">
                <C4FInfoButton title={'Category'} text={'C4F category of the race (1 .. 6)'} />
                <InputGroup.Text>Category</InputGroup.Text>
                <Form.Control type={'text'} value={selectedRace.category}
                  onChange={(e) => handleUpdateSelectedRace({ ...selectedRace, category: e.target.value })} />
              </InputGroup>
              <InputGroup className="mt-1" size="sm">
                <C4FInfoButton title={'Riders per Team'} text={'Number of riders per participating team for this race'} />
                <InputGroup.Text>Riders per Team</InputGroup.Text>
                <Form.Control type={'text'} value={selectedRace.ridersPerTeam}
                  onChange={(e) => handleUpdateSelectedRace({ ...selectedRace, ridersPerTeam: e.target.value })} />
              </InputGroup>
              <InputGroup className="mt-1" size="sm">
                <C4FInfoButton title={'Event'} text={'Name of recurring event, used to link previous editions of the race, even if the name changes meanwhile (e.g. Het Volk became Het Nieuwsblad)'} />
                <InputGroup.Text>Event</InputGroup.Text>
                <Form.Control type={'text'} value={recurringEventFilter}
                  onChange={(e) => { setRecurringEventFilter(e.target.value); setRecurringEventFilterRegex(new RegExp(e.target.value, 'i')); }} />
                <DropdownButton
                  title={selectedRace.recurringEvent}
                  variant={'outline-secondary'}
                  onSelect={(newValue, e) => handleUpdateRecurringEvent(newValue)}>
                  {[{ id: null, name: '' }].concat(recurringEvents).filter(re => re.name.match(recurringEventFilterRegex)).map(recurringEvent =>
                    <Dropdown.Item key={recurringEvent.id} eventKey={recurringEvent.name}>{recurringEvent.name}</Dropdown.Item>)
                  }
                </DropdownButton>
              </InputGroup>
              <InputGroup className="mt-1" size="sm">
                <C4FInfoButton title={'Ruleset'} text={'Name of the ruleset, which defines points and prizes for intermediates, final sprints, and in case of tours for daily and tour rewards'} />
                <InputGroup.Text>Ruleset</InputGroup.Text>
                <DropdownButton
                  title={selectedRace.rulesetName}
                  variant={'outline-secondary'}
                  onSelect={(newValue, e) => handleUpdateRulesetName(newValue)}>
                  {raceRulesets.map(ruleset =>
                    <Dropdown.Item key={ruleset.name} eventKey={ruleset.name}>{ruleset.name}</Dropdown.Item>)
                  }
                </DropdownButton>
              </InputGroup> */}
            </Col>
            : null}
        </Row>
        {selectedRace !== null ?
          <>
            {showRaceStages ?
              <>
                <Row className="mt-1 py-1 border border-secondary">
                  <Col>
                    <h5>Stages</h5>
                    <C4FSimpleTable key={'stages'}
                      initialSortingColumn={'number'}
                      initialSortingAscending={true}
                      hideColumnVisibility={true}
                      hideFilterButtons={true}
                      highlightCriteriaKey={'id'}
                      highlightCriteriaValue={selectedStage !== null ? selectedStage.id : null}
                      addRecord={addStage}
                      data={selectedRace.stages.map(stage => ({
                        ...stage,
                        nameTruncated: truncateString(stage.name, 28),
                        raceTypeFormatted: stage.raceType === 'IndividualTimeTrial' ?
                          'ITT' : (stage.raceType === 'TeamTimeTrial' ? 'TTT' : stage.raceType),
                        stageBonificationTypeFormatted: stage.stageBonificationType === 'IndividualTimeTrial' ?
                          'ITT' : (stage.stageBonificationType === 'TeamTimeTrial' ? 'TTT' : stage.stageBonificationType),
                        edit: '\u270E',
                        clone: '\u2398',
                        delete: '\u2715'
                      }))}
                      rowMetadata={[
                        { columnName: 'number', columnDescription: '#', cellClickEvent: userCanEditSelectedRace ? editStage : null },
                        { columnName: 'profileCode', columnDescription: 'ProfileCode', cellClickEvent: userCanEditSelectedRace ? editStage : null },
                        { columnName: 'nameTruncated', columnDescription: 'Name', cellClickEvent: userCanEditSelectedRace ? editStage : null },
                        { columnName: 'raceTypeFormatted', columnDescription: 'Race Type' },
                        { columnName: 'stageType', columnDescription: 'Stage Type' },
                        { columnName: 'stageBonificationTypeFormatted', columnDescription: 'Bonis' },
                        { columnName: 'length', columnDescription: 'Length' },
                        { columnName: 'elevationGain', columnDescription: 'HM' },
                        { columnName: 'minuteTactStart', columnDescription: 'Mintact' },
                        { columnName: 'profileStatus', columnDescription: 'Status' },
                        { columnName: 'clone', columnDescription: '\u2398', columnType: 'button', cellClickEvent: userCanEditSelectedRace ? cloneStage : null, className: 'py-0 btn-warning' },
                        { columnName: 'delete', columnDescription: '\u2715', columnType: 'button', cellClickEvent: userCanEditSelectedRace ? deleteStage : null, className: 'py-0 btn-danger' }
                      ]} />
                  </Col>
                </Row>
                {selectedStage !== null ?
                  <Row className="border border-secondary">
                    <Col>
                      {selectedRace.stages.length > 1 ?
                        <>
                          <InputGroup>
                            <C4FInfoButton title={'Number'} text={'Stage number within a tour, automatically updated when saving based on the order. I.e. if there are multiple stages with number one, numbers will be updated during saving.'} />
                            <InputGroup.Text>Number</InputGroup.Text>
                            <Form.Control type={'text'} value={selectedStage.number}
                              onChange={(e) => handleUpdateStage({ ...selectedStage, number: e.target.value })} />
                          </InputGroup>
                          <InputGroup>
                            <C4FInfoButton title={'Name'} text={'Name of the stage, only used for tour stages'} />
                            <InputGroup.Text>Name</InputGroup.Text>
                            <Form.Control type={'text'} value={selectedStage.name}
                              onChange={(e) => handleUpdateStage({ ...selectedStage, name: e.target.value })} />
                          </InputGroup>
                          <InputGroup>
                            <C4FInfoButton title={'Description'} text={'Description of the stage, only used for tour stages'} />
                            <InputGroup.Text>Description</InputGroup.Text>
                            <Form.Control type={'text'} value={selectedStage.description}
                              onChange={(e) => handleUpdateStage({ ...selectedStage, description: e.target.value })} />
                          </InputGroup>
                        </>
                        : null}
                      <InputGroup>
                        <C4FInfoButton title={'Race Type'} text={'Race type, for ITT and TTT this is synced with Bonifications'} />
                        <InputGroup.Text>Race Type</InputGroup.Text>
                        <DropdownButton
                          title={selectedStage.raceType}
                          variant={'outline-secondary'}
                          onSelect={(newValue, e) => handleUpdateStage({ ...selectedStage, raceType: newValue })}>
                          {['RestDay', 'Regular', 'TeamTimeTrial', 'IndividualTimeTrial'].map(raceType =>
                            <Dropdown.Item key={raceType} eventKey={raceType}>{raceType}</Dropdown.Item>)
                          }
                        </DropdownButton>
                      </InputGroup>
                      <InputGroup>
                        <C4FInfoButton title={'Stage Type'} text={'Almost always FullStage, except for setting half stages'} />
                        <InputGroup.Text>Stage Type</InputGroup.Text>
                        <DropdownButton
                          title={selectedStage.stageType}
                          variant={'outline-secondary'}
                          onSelect={(newValue, e) => handleUpdateStage({ ...selectedStage, stageType: newValue })}>
                          {['FullStage', 'FirstHalfStage', 'SecondHalfStage'].map(stageType =>
                            <Dropdown.Item key={stageType} eventKey={stageType}>{stageType}</Dropdown.Item>)
                          }
                        </DropdownButton>
                      </InputGroup>
                      <InputGroup>
                        <C4FInfoButton title={'Bonifications'} text={'Bonification type at the end of the stage'} />
                        <InputGroup.Text>Bonifications</InputGroup.Text>
                        <DropdownButton
                          title={selectedStage.stageBonificationType}
                          variant={'outline-secondary'}
                          onSelect={(newValue, e) => handleUpdateStage({ ...selectedStage, stageBonificationType: newValue })}>
                          {['Flat', 'Hilly', 'Mountain', 'IndividualTimeTrial', 'TeamTimeTrial'].map(stageBonificationType =>
                            <Dropdown.Item key={stageBonificationType} eventKey={stageBonificationType}>{stageBonificationType}</Dropdown.Item>)
                          }
                        </DropdownButton>
                      </InputGroup>
                      <InputGroup>
                        <C4FInfoButton title={'Profile Code'} text={'Profile code of the referenced profile with buttons for creating a profile with prepopulated data and automatically setting the currently active profile in the editor (only shown, when a profile is being edited)'} />
                        <InputGroup.Text>Profile Code</InputGroup.Text>
                        <Form.Control key={'stageProfileCode'} type={'text'} value={selectedStage.profileCode}
                          onChange={(e) => handleUpdateStage({ ...selectedStage, profileCode: e.target.value })} />
                        {(!('profileCode' in selectedStage) || selectedStage.profileCode === null || selectedStage.profileCode === '') ?
                          <>
                            {selectedEditorProfile !== null ?
                              <Button variant={'primary'} onClick={() => handleUpdateStage({ ...selectedStage, profileCode: selectedEditorProfile.profileCode })}>
                                Link to {selectedEditorProfile.profileCode}
                              </Button>
                              : null}
                            <Button variant={'primary'} onClick={() => createProfileForStage()}>Create New Profile</Button>
                          </>
                          :
                          <Button variant={'primary'} onClick={() => editProfileForStage()}>Edit Profile</Button>
                        }
                      </InputGroup>
                      <InputGroup>
                        <C4FInfoButton title={'Minute Tact'} text={'Start of minute tact of this race'} />
                        <InputGroup.Text>Minute Tact</InputGroup.Text>
                        <Form.Control type={'text'} value={selectedStage.minuteTactStart}
                          onChange={(e) => handleUpdateStage({ ...selectedStage, minuteTactStart: e.target.value })} />
                      </InputGroup>
                    </Col>
                  </Row>
                  : null}
              </>
              : null}
            {showRaceEditions ?
              <Row className="mt-1 py-1 border border-secondary">
                <Col className="col-6">
                  <h5>Race Editions</h5>
                  <C4FSimpleTable key={'raceEditions'}
                    highlightCriteriaKey={'id'}
                    highlightCriteriaValue={selectedRaceEdition !== null ? selectedRaceEdition.id : null}
                    hideFilterButtons={true}
                    hideColumnVisibility={true}
                    initialSortingColumn={'startingTime'}
                    initialSortingAscending={true}
                    addRecord={addRaceEdition}
                    data={selectedRace.raceEditions.map(raceEdition => ({
                      ...raceEdition,
                      edit: '\u270E',
                      clone: '\u2398',
                      delete: '\u2715'
                    }))}
                    rowMetadata={[
                      { columnName: 'startingDate', columnDescription: 'Date', cellClickEvent: userCanEditSelectedRace ? editRaceEdition : null },
                      { columnName: 'startingTime', columnDescription: 'Time', cellClickEvent: userCanEditSelectedRace ? editRaceEdition : null },
                      { columnName: 'minDivision', columnDescription: 'min Div' },
                      { columnName: 'maxDivision', columnDescription: 'max Div' },
                      { columnName: 'clone', columnDescription: '\u2398', columnType: 'button', cellClickEvent: userCanEditSelectedRace ? cloneRaceEdition : null, className: 'py-0 btn-warning' },
                      { columnName: 'delete', columnDescription: '\u2715', columnType: 'button', cellClickEvent: userCanEditSelectedRace ? deleteRaceEdition : null, className: 'py-0 btn-danger' }
                    ]} />
                </Col>
                {selectedRaceEdition !== null ?
                  <Col className="col-4">
                    <h5>Race Edition Details</h5>
                    <C4FSimpleTextField
                      type="date"
                      info={'Date of edition of this race'}
                      key={'startingDate'}
                      name={'startingDate'}
                      displayName={'Date'}
                      value={selectedRaceEdition.startingDate}
                      updateMethod={handleUpdateSelectedRaceEditionParameter} />
                    <C4FReferenceDataSelection className="mt-1"
                      info={'Time of edition of this race (8 - 24)'}
                      key={'startingTime'}
                      name={'startingTime'}
                      displayName={'Time'}
                      value={selectedRaceEdition.startingTime}
                      referenceDataValues={['8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24']}
                      updateMethod={handleUpdateSelectedRaceEditionParameter} />
                    <C4FSimpleTextField className="mt-1"
                      disabled
                      info={'Limitation of divisions for this specific race edition'}
                      key={'minDivision'}
                      name={'minDivision'}
                      displayName={'from Division'}
                      value={selectedRaceEdition.minDivision}
                      updateMethod={handleUpdateSelectedRaceEditionParameter} />
                    <C4FSimpleTextField className="mt-1"
                      disabled
                      info={'Limitation of divisions for this specific race edition'}
                      key={'maxDivision'}
                      name={'maxDivision'}
                      displayName={'to Division'}
                      value={selectedRaceEdition.maxDivision}
                      updateMethod={handleUpdateSelectedRaceEditionParameter} />
                    
                    
                    {/* <InputGroup>
                      <C4FInfoButton title={'Date / Time'} text={'Date and time of edition of this race'} />
                      <InputGroup.Text>Date / Time</InputGroup.Text>
                      <Form.Control type={'text'} value={selectedRaceEdition.startingDate}
                        onChange={(e) => handleUpdateRaceEdition({ ...selectedRaceEdition, startingDate: e.target.value })} />
                      <Form.Control type={'text'} value={selectedRaceEdition.startingTime}
                        onChange={(e) => handleUpdateRaceEdition({ ...selectedRaceEdition, startingTime: e.target.value })} />
                    </InputGroup> */}
                    {/* <InputGroup>
                      <C4FInfoButton title={'Division From / To'} text={'Limitation of divisions for this specific race edition'} />
                      <InputGroup.Text>Division From / To</InputGroup.Text>
                      <Form.Control type={'text'} value={selectedRaceEdition.minDivision}
                        onChange={(e) => handleUpdateRaceEdition({ ...selectedRaceEdition, minDivision: e.target.value })} />
                      <Form.Control type={'text'} value={selectedRaceEdition.maxDivision}
                        onChange={(e) => handleUpdateRaceEdition({ ...selectedRaceEdition, maxDivision: e.target.value })} />
                    </InputGroup> */}
                  </Col>
                  : null}
              </Row>
              : null}
          </>
          : null}
      </>
      : null}
    {tab === 'calendarChat' ?
      <Row className="justify-content-center">
         <div className="col m-0 p-1">
          <h5>Calendar Chat</h5>
          <div className="border border-secondary px-3 py-0" style={{ minWidth: 300, maxWidth: 700, backgroundColor: 'rgba(255, 255, 255, 1)' }}>
          <C4FChat key={'calendarChat'} type="calendarCoordination"
            mode="readwrite"
            chat={0} user={userInformation.userName}
            height={500} />
        </div>
        </div>
      </Row>
      : null}
    {tab === 'calendar' && races !== null ?
      <>
        <Row className="justify-content-center">
          <Col className="p-1">
            <C4FSimpleTable key={'calendarRaces'}
              highlightCriteriaKey={'id'}
              highlightCriteriaValue={selectedCalendarRace?.id}
              initialSortingColumn={'startingDate'}
              initialSortingAscending={true}
              hideColumnVisibility={true}
              refreshTable={loadCalendarRaces}
              data={calendarRaces
                .filter(race => race.status !== 'Draft')
                .map(race => ({
                  ...race,
                  startingDate: race.raceEditions[0].startingDate,
                  raceEditions: Array.from(race.raceEditions.map(re => re.startingTime)).join(', '),
                  designStatus: race.stages.filter(s => 'profileCode' in s).length + ' / ' + race.stages.filter(s => s.raceType !== 'RestDay').length
                }))}
              rowMetadata={[
                { columnName: 'startingDate', columnDescription: 'Date' },
                { columnName: 'raceEditions', columnDescription: 'Times' },
                { columnName: 'raceName', columnDescription: 'Race', cellClickEvent: handleSelectCalendarRace },
                { columnName: 'status', columnDescription: 'Status' },
                { columnName: 'designStatus', columnDescription: 'Profiles' },
                { columnName: 'recurringEvent', columnDescription: 'Rec. Event' },
                { columnName: 'category', columnDescription: 'Cat.' },
                { columnName: 'duration', columnDescription: 'Days' },
                { columnName: 'ridersPerTeam', columnDescription: 'Riders/Team' }
              ]
              }
            />
          </Col>
        </Row>
        {selectedCalendarRace ?
          <>
            {selectedCalendarRace.status === 'Published' && isAdmin() ?
              <Row className="justify-content-center">
                <Col className="p-1">
                  <Button size="sm" variant={'danger'} onClick={() => withdrawPublishedRace(selectedCalendarRace)}>Withdraw Race</Button>
                </Col>
              </Row>
              : null}
            <Row className="justify-content-center">
              <Col className="p-1">
                <C4FSimpleTable key={'calendarStages'}
                  highlightCriteriaKey={'number'}
                  highlightCriteriaValue={selectedCalendarStage.number}
                  hideFilterButtons={true}
                  hideColumnVisibility={true}
                  data={selectedCalendarRace.stages.map(stage => ({
                    ...stage,
                    stageTypeCombined: (stage.stageBonificationType === 'IndividualTimeTrial') ? 'ITT' : (stage.stageBonificationType === 'TeamTimeTrial' ? 'TTT' : stage.stageBonificationType) + (stage.stageType !== 'FullStage' ? ' (half stage)' : '')
                  }))}
                  rowMetadata={[
                    { columnName: 'number', columnDescription: '#' },
                    { columnName: 'name', columnDescription: 'Name', cellClickEvent: handleSelectCalendarStage },
                    { columnName: 'stageTypeCombined', columnDescription: 'Type' },
                    { columnName: 'length', columnDescription: 'Length' },
                    { columnName: 'elevationGain', columnDescription: 'Elevation' },
                    { columnName: 'minuteTactStart', columnDescription: 'Min-Tact' }
                  ]}
                />
              </Col>
            </Row>
          </>
          : null}
        {selectedCalendarStage ?
          <Row className="justify-content-center">
            {selectedCalendarProfile ?
              <>
                <Col className="col-2">
                  <C4FDetailedProfile key={selectedCalendarProfile.profileCode} profile={selectedCalendarProfile}
                    rulesetName={'RaceEditor'}
                    currentSector={0}
                    minuteTactStart={selectedCalendarStage.minuteTactStart}
                    lastSector={selectedCalendarProfile.sectors.length}
                    tablePos={580} />
                </Col>
                <Col className="col-8">
                  <Container className="border border-secondary m-0 p-0" style={{ maxWidth: 746, maxHeight: 240, backgroundColor: 'rgba(251, 253, 255, 1)' }}>
                    <img style={{ maxHeight: "100%", maxWidth: "100%" }}
                      alt="Race profile will be shown here."
                      src={config.DIR_PROFILES + selectedCalendarProfile.profileCode + ".png?" + refreshImage} />
                  </Container>
                </Col>
              </>
              :
              <h4>Stage not designed yet</h4>
            }
          </Row>
          : null}
      </>
      : null}
  </Container>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
  </>
}

export default RaceEditor;
